/* global XLSX, saveAs */ // Declaradas variáveis globais para ESLint
import React, { useState, useEffect, useCallback } from 'react';
import { 
  MessageSquare, TrendingUp, AlertCircle, CheckCircle, Clock, Filter, 
  Search, Download, Menu, X, Home, BarChart3, Settings, Users, Bell, 
  FileText, HelpCircle, LogOut, ChevronLeft, ChevronRight, Upload, 
  Send, XCircle, LogIn, User, Lock, Eye, EyeOff, ClipboardList, QrCode,
  PlusCircle, Edit, Trash2, Wifi, WifiOff, ListFilter, ChevronDown,
  Activity, // Adicionado Activity para o Log de Operações
  ChevronUp, // Adicionado ChevronUp para o agrupamento de logs
  Mail // Adicionado Mail para o ícone de e-mail na página de acesso
} from 'lucide-react';
import { 
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer,
  PieChart, Pie, Cell, BarChart, Bar // Importados componentes Recharts
} from 'recharts';


// REMOVIDOS OS IMPORTS DO FIREBASE


// Novo Componente: MfaModal
// Este componente é um modal para entrada do código MFA.
const MfaModal = ({ isOpen, onClose, onSubmit, isLoading, error, email, onResendCode }) => {
  const [code, setCode] = useState('');

  // Limpa o código quando o modal é fechado
  useEffect(() => {
    if (!isOpen) {
      setCode(''); 
    }
  }, [isOpen]);

  if (!isOpen) return null; // Não renderiza se não estiver aberto

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(code); // Chama a função de submissão passada como prop
  };

  return (
    <div className="fixed inset-0 bg-gray-900 bg-opacity-75 flex items-center justify-center z-[1000] p-4">
      <div className="bg-white rounded-2xl shadow-2xl p-8 sm:p-10 w-full max-w-md text-center relative">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
          aria-label="Fechar"
        >
          <X className="w-6 h-6" />
        </button>
        <QrCode className="w-16 h-16 text-blue-600 mx-auto mb-6" />
        <h2 className="text-2xl font-bold text-gray-800 mb-4">Verificação em Duas Etapas</h2>
        <p className="text-gray-600 mb-6">
          Um código de verificação foi enviado para <span className="font-semibold text-blue-700">{email}</span>.
          Por favor, insira o código abaixo para continuar.
        </p>

        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-lg relative mb-4">
            <span className="block sm:inline">{error}</span>
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="relative">
            <input
              type="text"
              placeholder="Código de 6 dígitos"
              className="w-full pl-4 pr-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200 text-center text-xl tracking-widest"
              value={code}
              onChange={(e) => setCode(e.target.value.replace(/[^0-9]/g, '').slice(0, 6))} // Apenas números, máximo 6 dígitos
              maxLength={6}
              required
            />
          </div>

          <button
            type="submit"
            className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white font-semibold py-3 px-6 rounded-xl hover:from-blue-700 hover:to-purple-700 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center shadow-md hover:shadow-lg"
            disabled={isLoading || code.length !== 6} // Desabilita se estiver carregando ou código incompleto
          >
            {isLoading ? (
              <>
                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-3"></div>
                Verificando...
              </>
            ) : (
              <>
                <CheckCircle className="w-5 h-5 mr-3" />
                Verificar Código
              </>
            )}
          </button>
          <button
            type="button"
            onClick={onResendCode}
            disabled={isLoading}
            className="w-full text-blue-600 hover:text-blue-800 font-medium mt-4 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Reenviar Código
          </button>
        </form>
      </div>
    </div>
  );
};

// Novo Componente: PurchaseAccessPage
const PurchaseAccessPage = ({ onReturnToLogin }) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-600 to-purple-700 p-4">
      <div className="bg-white rounded-2xl shadow-2xl p-8 sm:p-10 w-full max-w-md text-center">
        <div className="flex justify-center mb-6">
          <MessageSquare className="w-16 h-16 text-blue-600" />
        </div>
        <h1 className="text-3xl font-bold text-gray-800 mb-4">Obtenha Acesso ao MsgPanel</h1>
        <p className="text-gray-600 mb-8">
          Para utilizar todas as funcionalidades do nosso sistema, o acesso é liberado após a aquisição de um plano.
          Por favor, entre em contato com nossa equipe de suporte para mais informações e para adquirir seu acesso.
        </p>
        <div className="space-y-4">
          <a 
            href="mailto:atendimento@abletecbrasil.com.br?subject=Interesse%20em%20acesso%20ao%20MsgPanel"
            className="w-full bg-gradient-to-r from-green-500 to-emerald-600 text-white font-semibold py-3 px-6 rounded-xl hover:from-green-600 hover:to-emerald-700 transition-all duration-200 flex items-center justify-center shadow-md hover:shadow-lg"
          >
            <Mail className="w-5 h-5 mr-3" />
            Contate o Suporte por E-mail
          </a>
          <a 
            href="https://wa.me/5521984537533" // Substituído pelo número de WhatsApp real do suporte
            target="_blank"
            rel="noopener noreferrer"
            className="w-full bg-green-500 text-white font-semibold py-3 px-6 rounded-xl hover:bg-green-600 transition-all duration-200 flex items-center justify-center shadow-md hover:shadow-lg"
          >
            <MessageSquare className="w-5 h-5 mr-3" />
            Fale Conosco pelo WhatsApp
          </a>
          <button
            onClick={onReturnToLogin}
            className="w-full bg-gray-200 text-gray-800 font-semibold py-3 px-6 rounded-xl hover:bg-gray-300 transition-all duration-200 flex items-center justify-center shadow-sm hover:shadow-md mt-6"
          >
            <ChevronLeft className="w-5 h-5 mr-3" />
            Voltar para o Login
          </button>
        </div>
      </div>
    </div>
  );
};


// Novo Componente: ForgotPasswordPage
const ForgotPasswordPage = ({ onReturnToLogin }) => {
  const [email, setEmail] = useState('');
  const [token, setToken] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const [step, setStep] = useState('email_input'); // 'email_input', 'token_password_input', 'success'
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  // const [tokenSent, setTokenSent] = useState(false); // Não é mais necessário, pois 'step' gerencia o estado

  const REQUEST_TOKEN_API_URL = 'https://app.n8n.able.tec.br/api/webhook/msgpanel/mfa/request-code';
  const RESET_PASSWORD_API_URL = 'https://app.n8n.able.tec.br/api/webhook/msgpanel/esqueci-senha';

  const handleRequestToken = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMessage('');
    setLoading(true);

    try {
      const url = `${REQUEST_TOKEN_API_URL}?email=${encodeURIComponent(email)}`;
      const response = await fetch(url, { method: 'GET' });

      // Se a resposta HTTP for OK (status 2xx), assume que o token foi enviado
      // Mesmo que a API retorne um JSON diferente de {status: 'success'},
      // se a requisição foi bem-sucedida, avançamos.
      if (response.ok) {
        const result = await response.json(); // Ainda parseia para logar a resposta real
        console.log('Resposta da API para solicitação de token:', result); 
        setStep('token_password_input');
        setSuccessMessage('Um código de verificação foi enviado para o seu e-mail. Por favor, insira-o junto com sua nova senha.');
      } else {
        let errorData = {};
        try {
          errorData = await response.json();
        } catch (parseError) {
          console.error('Erro ao parsear JSON da resposta de erro de token:', parseError);
          throw new Error(`Erro HTTP ${response.status}: ${response.statusText || 'Resposta inesperada do servidor.'}`);
        }
        throw new Error(errorData.message || `Erro HTTP ${response.status}: ${response.statusText || 'Erro desconhecido do servidor.'}`);
      }

    } catch (err) {
      console.error('Erro ao solicitar token:', err);
      // Melhorando a mensagem de erro para "Failed to fetch"
      if (err instanceof TypeError && err.message === 'Failed to fetch') {
        setError('Não foi possível conectar ao servidor para solicitar o token. Por favor, verifique sua conexão com a internet ou entre em contato com o suporte.');
      } else {
        setError(`Falha ao solicitar o token: ${err.message}.`);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();
    setError('');
    setSuccessMessage('');
    setLoading(true);

    if (newPassword !== confirmNewPassword) {
      setError('As senhas não coincidem. Por favor, digite a mesma senha nos dois campos.');
      setLoading(false);
      return;
    }

    if (newPassword.length < 6) { // Exemplo de validação de senha
      setError('A nova senha deve ter no mínimo 6 caracteres.');
      setLoading(false);
      return;
    }

    try {
      const payload = {
        email: email,
        senha: newPassword,
        token: token
      };

      const response = await fetch(RESET_PASSWORD_API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      });

      if (response.ok) {
        const result = await response.json();
        console.log('API response for password reset:', result); // Log the full result for debugging
        
        // Check for explicit success status OR the specific success message
        if (result && result.status === 'success' || (result && result.message === "Pedido processado com sucesso")) {
          setStep('success');
          setSuccessMessage(result.message || 'Sua senha foi redefinida com sucesso! Você pode retornar à tela de login.');
          setLoading(false); // Set loading to false on success
          return; // Exit function on success
        } else {
          // If HTTP is OK, but API logic indicates failure (e.g., status is not 'success' and message is not the specific success one)
          setError(result.message || 'Falha ao redefinir a senha. Verifique o token e tente novamente.');
        }
      } else {
        let errorData = {};
        try {
          errorData = await response.json();
        } catch (parseError) {
          console.error('Erro ao parsear JSON da resposta de erro de reset de senha:', parseError);
          setError(`Erro HTTP ${response.status}: ${response.statusText || 'Resposta inesperada do servidor.'}`);
          setLoading(false); // Set loading to false on HTTP error
          return; // Exit function on HTTP error
        }
        setError(errorData.message || `Erro HTTP ${response.status}: ${response.statusText || 'Erro desconhecido do servidor.'}`);
      }
    } catch (err) {
      console.error('Erro ao redefinir senha:', err);
      if (err instanceof TypeError && err.message === 'Failed to fetch') {
        setError('Não foi possível conectar ao servidor para redefinir a senha. Por favor, verifique sua conexão com a internet ou entre em contato com o suporte.');
      } else {
        setError(`Falha ao redefinir a senha: ${err.message}.`);
      }
    } finally {
      // This finally block will only run if not returned early (i.e., on error paths not caught by specific returns)
      // Ensure loading is false if it wasn't already set in a return path
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-600 to-purple-700 p-4">
      <div className="bg-white rounded-2xl shadow-2xl p-8 sm:p-10 w-full max-w-md text-center">
        <div className="flex justify-center mb-6">
          <Lock className="w-16 h-16 text-blue-600" />
        </div>
        <h1 className="text-3xl font-bold text-gray-800 mb-4">Esqueceu a Senha?</h1>
        <p className="text-gray-600 mb-8">
          {step === 'email_input' && "Informe seu e-mail para receber um código de verificação."}
          {step === 'token_password_input' && "Um código foi enviado para o seu e-mail. Insira-o abaixo junto com sua nova senha."}
          {step === 'success' && "Sua senha foi redefinida com sucesso!"}
        </p>

        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-lg relative mb-4">
            <span className="block sm:inline">{error}</span>
            <span className="absolute top-0 bottom-0 right-0 px-4 py-3 cursor-pointer" onClick={() => setError('')}>
              <X className="h-5 w-5 text-red-500" />
            </span>
          </div>
        )}
        {successMessage && (
          <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded-lg relative mb-4">
            <span className="block sm:inline">{successMessage}</span>
            <span className="absolute top-0 bottom-0 right-0 px-4 py-3 cursor-pointer" onClick={() => setSuccessMessage('')}>
              <X className="h-5 w-5 text-green-500" />
            </span>
          </div>
        )}

        {step === 'email_input' && (
          <form onSubmit={handleRequestToken} className="space-y-6">
            <div className="relative">
              <Mail className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
              <input
                type="email"
                placeholder="Seu e-mail"
                className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <button
              type="submit"
              className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white font-semibold py-3 px-6 rounded-xl hover:from-blue-700 hover:to-purple-700 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center shadow-md hover:shadow-lg"
              disabled={loading}
            >
              {loading ? (
                <>
                  <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-3"></div>
                  Enviando Código...
                </>
              ) : (
                <>
                  <Send className="w-5 h-5 mr-3" />
                  Enviar Código de Verificação
                </>
              )}
            </button>
          </form>
        )}

        {step === 'token_password_input' && (
          <form onSubmit={handleResetPassword} className="space-y-6">
            <div className="relative">
              <QrCode className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
              <input
                type="text"
                placeholder="Código de Verificação"
                className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                value={token}
                onChange={(e) => setToken(e.target.value)}
                required
              />
            </div>
            <div className="relative">
              <Lock className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
              <input
                type="password"
                placeholder="Nova Senha"
                className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                required
              />
            </div>
            <div className="relative">
              <Lock className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
              <input
                type="password"
                placeholder="Confirmar Nova Senha"
                className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
                value={confirmNewPassword}
                onChange={(e) => setConfirmNewPassword(e.target.value)}
                required
              />
            </div>
            <button
              type="submit"
              className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white font-semibold py-3 px-6 rounded-xl hover:from-blue-700 hover:to-purple-700 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center shadow-md hover:shadow-lg"
              disabled={loading}
            >
              {loading ? (
                <>
                  <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-3"></div>
                  Redefinindo Senha...
                </>
              ) : (
                <>
                  <CheckCircle className="w-5 h-5 mr-3" />
                  Redefinir Senha
                </>
              )}
            </button>
            <button
              type="button"
              onClick={handleRequestToken} // Permite reenviar o token
              disabled={loading}
              className="w-full text-blue-600 hover:text-blue-800 font-medium mt-4 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Reenviar Código
            </button>
          </form>
        )}

        {step === 'success' && (
          <div className="mt-6">
            <CheckCircle className="w-16 h-16 text-green-600 mx-auto mb-4" />
            <p className="text-lg text-gray-700 mb-6">{successMessage}</p>
          </div>
        )}

        <button
          onClick={onReturnToLogin}
          className="w-full bg-gray-200 text-gray-800 font-semibold py-3 px-6 rounded-xl hover:bg-gray-300 transition-all duration-200 flex items-center justify-center shadow-sm hover:shadow-md mt-6"
        >
          <ChevronLeft className="w-5 h-5 mr-3" />
          Voltar para o Login
        </button>
      </div>
    </div>
  );
};


// 1. Componente LoginPage
// Este componente lida com a interface e lógica de login.
const LoginPage = ({ onLoginSuccess, onPurchaseAccess, onForgotPasswordClick }) => { // Adicionado onForgotPasswordClick
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // Novos estados para MFA
  const [showMfaModal, setShowMfaModal] = useState(false);
  const [mfaCode, setMfaCode] = useState('');
  const [mfaError, setMfaError] = useState('');
  const [mfaLoading, setMfaLoading] = useState(false);
  const [userEmailForMfa, setUserEmailForMfa] = useState(''); // Para exibir no modal MFA
  const [tempUserId, setTempUserId] = useState(null); // Armazenar userId após login inicial

  // Função para autenticar o usuário via webhook (primeira etapa: usuário/senha)
  const authenticateUser = async (email, senha) => {
    try {
      setLoading(true);
      setError('');

      const params = new URLSearchParams({ email, senha }).toString();
      const url = `https://app.n8n.able.tec.br/webhook/msgpanel/login?${params}`;

      console.log('Attempting to fetch from URL:', url);

      const response = await fetch(url, {
        method: 'GET',
      });

      console.log('Fetch response received:', response);

      if (!response.ok) {
        let errorData = {};
        try {
          errorData = await response.json();
        } catch (parseError) {
          console.error('Erro ao parsear JSON da resposta de erro:', parseError);
          throw new Error(`Erro HTTP ${response.status}: ${response.statusText || 'Resposta inesperada do servidor.'}`);
        }
        throw new Error(errorData.message || `Erro HTTP ${response.status}: ${response.statusText || 'Erro desconhecido do servidor.'}`);
      }

      const result = await response.json();
      console.log('Parsed JSON result:', result);

      if (result && result.valido) {
        // Autenticação de usuário/senha bem-sucedida. Agora, solicitar MFA.
        setUserEmailForMfa(email);
        setTempUserId(result.id || null); // Armazena o userId para a etapa MFA

        // Solicitar código MFA
        try {
          setMfaLoading(true);
          // O serviço /mfa/request-code espera um campo 'email'
          const mfaRequestUrl = `https://app.n8n.able.tec.br/api/webhook/msgpanel/mfa/request-code?email=${encodeURIComponent(email)}`;
          console.log('Requesting MFA code from:', mfaRequestUrl);
          const mfaResponse = await fetch(mfaRequestUrl, { method: 'GET' });

          if (!mfaResponse.ok) {
            let errorDetails = `Erro HTTP ${mfaResponse.status}: ${mfaResponse.statusText}`;
            try {
              const mfaErrorData = await mfaResponse.json();
              errorDetails = mfaErrorData.message || JSON.stringify(mfaErrorData);
            } catch (parseError) {
              // If response is not JSON, try to read as text
              const rawErrorText = await mfaResponse.text();
              errorDetails = rawErrorText || errorDetails;
            }
            // MODIFICAÇÃO AQUI: Mensagem de erro mais amigável
            throw new Error(`Não foi possível solicitar o código MFA. Detalhes do erro: ${errorDetails}. Por favor, verifique o serviço de MFA.`);
          }
          const mfaResult = await mfaResponse.json();
          console.log('MFA Request successful:', mfaResult);
          setShowMfaModal(true); // Exibe o modal MFA
          setMfaError(''); // Limpa quaisquer erros MFA anteriores
          return { success: true, message: 'Código MFA enviado. Verifique seu e-mail.' }; // Indica que a etapa MFA foi iniciada
        } catch (mfaErr) {
          console.error('Erro ao solicitar MFA:', mfaErr);
          setError(`Falha na autenticação de dois fatores: ${mfaErr.message}`);
          return { success: false, message: `Falha na autenticação de dois fatores: ${mfaErr.message}` };
        } finally {
          setMfaLoading(false);
        }
      } else {
        console.warn("Resultado inválido ou nulo:", result);
        return { success: false, message: result?.message || 'Usuário ou senha inválidos.' };
      }

    } catch (err) {
      console.error('Erro de login:', err);
      if (err.message.includes('Failed to fetch')) {
        return { success: false, message: 'Não foi possível conectar ao servidor de login. Verifique sua conexão de internet ou se o serviço está online.' };
      } else if (err.message.includes('Erro HTTP')) {
        return { success: false, message: `Erro na comunicação com o servidor: ${err.message}. Por favor, tente novamente.` };
      } else {
        return { success: false, message: 'Ocorreu um erro inesperado ao tentar fazer login. Por favor, tente novamente.' };
      }
    } finally {
      setLoading(false);
    }
  };

  // Função para verificar o código MFA
  const verifyMfaCode = async (code) => {
    if (!code.trim()) {
      setMfaError('Por favor, insira o código MFA.');
      return;
    }
    if (!userEmailForMfa) { // Usar userEmailForMfa para a verificação
      setMfaError('Erro interno: E-mail do usuário não encontrado para verificação MFA.');
      return;
    }

    setMfaLoading(true);
    setMfaError('');
    try {
      // O serviço /mfa/verify-code espera os campos 'email' e 'code'
      const mfaVerifyUrl = `https://app.n8n.able.tec.br/api/webhook/msgpanel/mfa/verify-code?email=${encodeURIComponent(userEmailForMfa)}&code=${encodeURIComponent(code)}`;
      console.log('Verifying MFA code from:', mfaVerifyUrl);
      const verifyResponse = await fetch(mfaVerifyUrl, { method: 'GET' });

      if (!verifyResponse.ok) {
        let verifyErrorData = {};
        try {
          verifyErrorData = await verifyResponse.json();
        } catch (parseError) {
          console.error('Erro ao parsear JSON da resposta de erro de verificação MFA:', parseError);
          throw new Error(`Código MFA inválido ou expirado: ${verifyResponse.statusText}`);
        }
        throw new Error(verifyErrorData.message || `Código MFA inválido ou expirado: ${verifyResponse.statusText}`);
      }
      const verifyResult = await verifyResponse.json();
      console.log('MFA Verification successful:', verifyResult);

      if (verifyResult && verifyResult.status === 'success') {
        // Sucesso final, prosseguir com o login completo
        const role = userEmailForMfa.endsWith('@abletecbrasil.com.br') ? 'admin' : 'user';
        onLoginSuccess(role, tempUserId); // Chama a função de sucesso do login principal
        setShowMfaModal(false); // Fecha o modal MFA
        setMfaCode(''); // Limpa o código MFA
      } else {
        setMfaError(verifyResult?.message || 'Código MFA inválido. Tente novamente.');
      }
    } catch (err) {
      console.error('Erro na verificação MFA:', err);
      setMfaError(`Falha na verificação do código: ${err.message}`);
    } finally {
      setMfaLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    // A função authenticateUser agora gerencia a solicitação de MFA
    const result = await authenticateUser(username, password); 

    if (!result.success) {
      setError(result.message); // Exibe erro do login inicial ou da solicitação MFA
    }
    // Se result.success for true, significa que o código MFA foi solicitado e o modal será exibido.
    // onLoginSuccess é chamado dentro de verifyMfaCode após a validação do MFA.
    setLoading(false); // Garante que o estado de carregamento é desativado após a tentativa inicial de autenticação
  };

  const handleResendMfaCode = async () => {
    setMfaError('');
    setMfaCode('');
    await authenticateUser(userEmailForMfa, password); // Re-solicita o código MFA
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-600 to-purple-700 p-4">
      <div className="bg-white rounded-2xl shadow-2xl p-8 sm:p-10 w-full max-w-md text-center">
        <div className="flex justify-center mb-6">
          <MessageSquare className="w-16 h-16 text-blue-600" />
        </div>
        <h1 className="text-3xl font-bold text-gray-800 mb-2">Bem-vindo ao MsgPanel</h1>
        <p className="text-gray-500 mb-8">Faça login para continuar</p>

        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-lg relative mb-4">
            <span className="block sm:inline">{error}</span>
            <span className="absolute top-0 bottom-0 right-0 px-4 py-3 cursor-pointer" onClick={() => setError('')}>
              <X className="h-5 w-5 text-red-500" />
            </span>
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="relative">
            <User className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
            <input
              type="text"
              placeholder="Nome de usuário ou e-mail"
              className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>
          
          <div className="relative">
            <Lock className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400" />
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder="Senha"
              className="w-full pl-12 pr-12 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
              aria-label={showPassword ? 'Esconder senha' : 'Mostrar senha'}
            >
              {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
            </button>
          </div>

          <div className="flex justify-between items-center text-sm">
            <label className="flex items-center text-gray-600 cursor-pointer">
              <input type="checkbox" className="form-checkbox h-4 w-4 text-blue-600 rounded" />
              <span className="ml-2">Lembrar-me</span>
            </label>
            <a href="#" onClick={onForgotPasswordClick} className="text-blue-600 hover:text-blue-800 font-medium transition-colors duration-200">
              Esqueceu a senha?
            </a>
          </div>

          <button
            type="submit"
            className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white font-semibold py-3 px-6 rounded-xl hover:from-blue-700 hover:to-purple-700 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center shadow-md hover:shadow-lg"
            disabled={loading}
          >
            {loading ? (
              <>
                <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-3"></div>
                Entrando...
              </>
            ) : (
              <>
                <LogIn className="w-5 h-5 mr-3" />
                Entrar
              </>
            )}
          </button>
        </form>

        <p className="text-gray-500 text-sm mt-8">
          Não tem uma conta?{' '}
          <button 
            onClick={onPurchaseAccess} // Chama a nova prop para ir para a página de compra de acesso
            className="text-blue-600 hover:text-blue-800 font-medium transition-colors duration-200"
          >
            Obtenha Acesso
          </button>
        </p>
      </div>

      {/* Modal de MFA */}
      <MfaModal
        isOpen={showMfaModal}
        onClose={() => { setShowMfaModal(false); setMfaError(''); setMfaCode(''); }}
        onSubmit={(code) => { setMfaCode(code); verifyMfaCode(code); }}
        isLoading={mfaLoading}
        error={mfaError}
        email={userEmailForMfa}
        onResendCode={handleResendMfaCode}
      />
    </div>
  );
};

// 2. Componente ExcelMessageSender
// Este componente lida com a lógica de upload de Excel, template de mensagem e envio.
const ExcelMessageSender = ({ onSendingComplete, userId, sessionStatus, loadingSessionStatus, setCurrentPage }) => {
  const [file, setFile] = useState(null);
  const [contacts, setContacts] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);
  const [messageTemplate, setMessageTemplate] = useState('');
  const [sendingStatus, setSendingStatus] = useState('idle');
  const [sendingProgress, setSendingProgress] = useState(0); // FIX: Changed to useState(0)
  
  const [messageSource, setMessageSource] = useState('custom');
  const [selectedMessageColumn, setSelectedMessageColumn] = useState('');
  const [selectedPhoneColumn, setSelectedPhoneColumn] = useState(''); // FIX: Changed to useState('')

  const [errorMessage, setErrorMessage] = useState('');
  const [availableVariables, setAvailableVariables] = useState([]);
  const [previewMessage, setPreviewMessage] = useState('');

  const WEBSERVICE_URL = 'https://app.n8n.able.tec.br/webhook/msgpanel/registrar';

  // Dynamically load XLSX and FileSaver libraries from CDN
  useEffect(() => {
    const loadScript = (src, id) => {
      if (!document.getElementById(id)) {
        const script = document.createElement('script');
        script.src = src;
        script.id = id;
        script.async = true;
        document.head.appendChild(script);

        return new Promise((resolve, reject) => {
          script.onload = resolve;
          script.onerror = () => {
            console.error(`Failed to load script: ${src}`);
            reject(new Error(`Failed to load script: ${src}`));
          };
        });
      }
      return Promise.resolve();
    };

    const loadLibraries = async () => {
      try {
        await loadScript('https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js', 'xlsx-script');
        await loadScript('https://cdnjs.cloudflare.com/ajax/libs/FileSaver.js/2.0.5/FileSaver.min.js', 'filesaver-script');
        setErrorMessage('');
      } catch (error) {
        setErrorMessage('Falha ao carregar bibliotecas externas (XLSX, FileSaver). Por favor, tente recarregar a página.');
      }
    };

    loadLibraries();

    return () => {
      const xlsxScript = document.getElementById('xlsx-script');
      const filesaverScript = document.getElementById('filesaver-script');
      if (xlsxScript) xlsxScript.remove(); 
      if (filesaverScript) filesaverScript.remove();
    };
  }, []);

  const resetSender = () => {
    setFile(null);
    setContacts([]);
    setIsProcessing(false);
    setMessageTemplate('');
    setSendingStatus('idle');
    setSendingProgress(0);
    setErrorMessage('');
    setAvailableVariables([]);
    setPreviewMessage('');
    setMessageSource('custom');
    setSelectedMessageColumn('');
    setSelectedPhoneColumn('');
  };

  const downloadExampleFile = () => {
    if (typeof XLSX === 'undefined') {
      setErrorMessage('A biblioteca XLSX não está carregada. Por favor, aguarde um momento ou atualize a página.');
      return;
    }
    const exampleData = [
      { Nome: 'João Silva', Telefone: '(11) 99999-1234', Email: 'joao@email.com', Mensagem: 'Olá João, sua mensagem personalizada está aqui!' },
      { Nome: 'Maria Santos', Telefone: '(11) 88888-5678', Email: 'maria@email.com', Mensagem: 'Oi Maria, temos novidades para você.' },
      { Nome: 'Pedro Oliveira', Telefone: '(11) 77777-9012', Email: 'pedro@email.com', Mensagem: 'Pedro, sua fatura está disponível.' },
      { Nome: 'Ana Costa', Telefone: '(11) 66666-3456', Email: 'ana@email.com', Mensagem: 'Ana, não perca essa oferta!' },
      { Nome: 'Carlos Ferreira', Telefone: '(11) 55555-7890', Email: 'carlos@email.com', Mensagem: 'Carlos, seu pedido foi enviado.' },
      { Nome: 'Lucia Rocha', Telefone: '(11) 44444-2345', Email: 'lucia@email.com', Mensagem: 'Lucia, lembrete de agendamento.' },
      { Nome: 'Roberto Lima', Telefone: '(11) 33333-6789', Email: 'roberto@email.com', Mensagem: 'Roberto, atualização importante.' },
      { Nome: 'Fernanda Alves', Telefone: '(11) 22222-0123', Email: 'fernanda@email.com', Mensagem: 'Fernanda, venha conferir!' }
    ];
    
    const ws = XLSX.utils.json_to_sheet(exampleData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Contatos');
    XLSX.writeFile(wb, 'exemplo-contatos.xlsx');
  };

  const handleFileUpload = useCallback((event) => {
    setErrorMessage('');
    if (typeof XLSX === 'undefined') {
      setErrorMessage('A biblioteca XLSX não está carregada. Por favor, aguarde um momento ou atualize a página.');
      return;
    }
    const uploadedFile = event.target.files[0];
    if (uploadedFile && uploadedFile.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
      setFile(uploadedFile);
      processExcelFile(uploadedFile);
    } else {
      setErrorMessage('Por favor, selecione um arquivo Excel válido (.xlsx).');
      setFile(null);
      setContacts([]);
      setAvailableVariables([]);
      setSelectedMessageColumn('');
      setSelectedPhoneColumn('');
    }
  }, []);

  const processExcelFile = async (file) => {
    setIsProcessing(true);
    setContacts([]);
    setAvailableVariables([]);
    try {
      if (typeof XLSX === 'undefined') {
        setErrorMessage('A biblioteca XLSX não está carregada. Por favor, aguarde um momento ou atualize a página.');
        setIsProcessing(false);
        return;
      }
      const data = await file.arrayBuffer();
      const workbook = XLSX.read(data);
      const sheetName = workbook.SheetNames[0];
      const worksheet = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], { header: 1 })[0]; // Get headers from the first row
      setAvailableVariables(worksheet || []);

      const jsonData = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]); // Get full JSON data with inferred headers
      
      const processedContacts = jsonData.map((row, index) => {
        const contact = { id: index + 1, status: 'pending' };
        Object.keys(row).forEach(header => { // Iterate over actual keys from the row
          contact[String(header).toLowerCase()] = row[header] || '';
        });
        return contact;
      });
      
      setContacts(processedContacts);

      if (worksheet.some(h => String(h).toLowerCase() === 'mensagem')) {
        setSelectedMessageColumn('mensagem');
        setMessageSource('column');
      } else {
        setMessageSource('custom');
      }

      if (worksheet.some(h => String(h).toLowerCase() === 'telefone')) {
        setSelectedPhoneColumn('telefone');
      }


    } catch (error) {
      console.error('Erro ao processar arquivo:', error);
      setErrorMessage('Erro ao processar o arquivo Excel. Verifique o formato e as permissões.');
      setFile(null);
      setContacts([]);
      setAvailableVariables([]);
      setSelectedMessageColumn('');
      setSelectedPhoneColumn('');
      setMessageSource('custom');
    } finally {
      setIsProcessing(false);
    }
  };

  const getPreviewMessage = useCallback(() => {
    if (contacts.length === 0) {
      return 'Carregue um arquivo para ver a pré-visualização com dados reais.';
    }

    const firstContact = contacts[0];
    let message = '';

    if (messageSource === 'custom') {
      message = messageTemplate;
    } else if (messageSource === 'column' && selectedMessageColumn) {
      message = String(firstContact[selectedMessageColumn] || ''); 
    } else {
      return 'Selecione uma opção de mensagem e carregue um arquivo.';
    }

    availableVariables.forEach(variable => {
      const key = String(variable).toLowerCase();
      const placeholder = `{${key}}`;
      const value = String(firstContact[key] || `[${String(variable).toUpperCase()} INDEFINIDO]`);
      message = message.split(placeholder).join(value);
    });

    message = message.replace(/\*(.*?)\*/g, '<strong>$1</strong>');
    message = message.replace(/_(.*?)_/g, '<em>$1</em>');
    message = message.replace(/~(.*?)~/g, '<del>$1</del>');

    return message;
  }, [messageSource, messageTemplate, selectedMessageColumn, contacts, availableVariables]);

  useEffect(() => {
    setPreviewMessage(getPreviewMessage());
  }, [getPreviewMessage]);


  const sendMessageToWebservice = async (contact, finalMessage) => {
    try {
      if (!userId) {
        throw new Error("ID do usuário não disponível. Por favor, faça login novamente.");
      }
      if (!selectedPhoneColumn || !contact[selectedPhoneColumn]) {
        throw new Error("Coluna de telefone não selecionada ou valor de telefone ausente para o contato.");
      }

      const payload = {
        id: userId,
        telefone: String(contact[selectedPhoneColumn]),
        mensagem: finalMessage
      };

      console.log('Sending payload to webservice:', payload);

      const response = await fetch(WEBSERVICE_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      });

      console.log('Webservice response received:', response);

      if (!response.ok) {
        let errorData = {};
        try {
          errorData = await response.json();
        } catch (parseError) {
          console.error('Erro ao parsear JSON da resposta de erro do webservice:', parseError);
          throw new Error(`Erro HTTP ${response.status}: ${response.statusText || 'Resposta inesperada do webservice.'}`);
        }
        throw new Error(errorData.message || `Erro HTTP ${response.status}: ${errorData.error || 'Erro desconhecido do webservice.'}`);
      }

      const result = await response.json();
      console.log('Parsed webservice result:', result);
      return { status: 'success', message: result.message || 'Mensagem registrada com sucesso.' };
    } catch (error) {
      console.error('Erro ao enviar mensagem para o webservice:', error);
      return { status: 'error', message: `Falha no envio: ${error.message}` };
    }
  };

  const initiateSending = async () => {
    if (contacts.length === 0) {
      setErrorMessage('Por favor, faça o upload de um arquivo com contatos.');
      return;
    }

    if (!selectedPhoneColumn) {
      setErrorMessage('Por favor, selecione a coluna que contém o telefone.');
      return;
    }

    if (messageSource === 'custom' && !messageTemplate.trim()) {
      setErrorMessage('Por favor, digite uma mensagem no campo de texto.');
      return;
    }
    if (messageSource === 'column' && !selectedMessageColumn) {
      setErrorMessage('Por favor, selecione a coluna que contém a mensagem.');
      return;
    }

    setErrorMessage('');
    setSendingStatus('sending');
    setSendingProgress(0);
    
    const currentSendingResults = {
      total: contacts.length,
      sent: 0,
      failed: 0,
      details: []
    };

    const contactsToSend = [...contacts];

    for (let i = 0; i < contactsToSend.length; i++) {
      const contact = contactsToSend[i];
      let finalMessage = '';

      if (messageSource === 'custom') {
        finalMessage = messageTemplate;
      } else if (messageSource === 'column') {
        finalMessage = String(contact[selectedMessageColumn] || ''); 
      }

      availableVariables.forEach(variable => {
        const key = String(variable).toLowerCase();
        const placeholder = `{${key}}`;
        const value = String(contact[key] || `[${String(variable).toUpperCase()} INDEFINIDO]`);
        finalMessage = finalMessage.split(placeholder).join(value);
      });

      const sendResult = await sendMessageToWebservice(contact, finalMessage);
      
      if (sendResult.status === 'success') {
        currentSendingResults.sent++;
        contact.status = 'sent';
        currentSendingResults.details.push({
          id: contact.id,
          name: contact.nome,
          telefone: contact[selectedPhoneColumn],
          status: 'success',
          message: sendResult.message
        });
      } else {
        currentSendingResults.failed++;
        contact.status = 'failed';
        currentSendingResults.details.push({
          id: contact.id,
          name: contact.nome,
          telefone: contact[selectedPhoneColumn],
          status: 'error',
          message: sendResult.message
        });
      }
      
      setSendingProgress(((i + 1) / contactsToSend.length) * 100);
    }
    
    setSendingStatus('completed');
    if (onSendingComplete) {
      onSendingComplete(currentSendingResults);
    }
  };

  // Conditional rendering for session status
  if (loadingSessionStatus) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600 text-lg">Verificando status da sessão...</p>
        </div>
      </div>
    );
  }

  // Changed condition from 'STARTING' to 'WORKING'
  if (sessionStatus !== 'WORKING') {
    return (
      <div className="fixed inset-0 bg-gray-900 bg-opacity-75 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-2xl shadow-2xl p-8 sm:p-10 w-full max-w-md text-center">
          <AlertCircle className="w-20 h-20 text-red-500 mx-auto mb-6" />
          <h2 className="text-3xl font-bold text-gray-800 mb-4">Sessão WhatsApp Não Ativa!</h2>
          <p className="text-gray-600 mb-6 text-lg">
            Para enviar mensagens, sua sessão do WhatsApp precisa estar ativa.
            O status atual é: <span className="font-semibold text-red-600">{sessionStatus || 'Desconhecido'}</span>.
          </p>
          <button
            onClick={() => setCurrentPage('settings')}
            className="w-full bg-gradient-to-r from-blue-600 to-purple-600 text-white font-semibold py-3 px-6 rounded-xl hover:from-blue-700 hover:to-purple-700 transition-all duration-200 flex items-center justify-center shadow-md hover:shadow-lg"
          >
            <Settings className="w-5 h-5 mr-3" />
            Ir para Configurações
          </button>
          <p className="text-gray-500 text-sm mt-4">
            Inicie a sessão e tente novamente.
          </p>
        </div>
      </div>
    );
  }


  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-gray-800 mb-2">
            Envio de Mensagens em Massa
          </h1>
        </div>

        {errorMessage && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4" role="alert">
            <strong className="font-bold">Erro!</strong>
            <span className="block sm:inline ml-2">{errorMessage}</span>
            <span className="absolute top-0 bottom-0 right-0 px-4 py-3 cursor-pointer" onClick={() => setErrorMessage('')}>
              <X className="h-6 w-6 text-red-500" />
            </span>
          </div>
        )}

        <div className="grid grid-cols-1 xl:grid-cols-3 gap-8">
          <div className="xl:col-span-1">
            <div className="bg-white rounded-2xl shadow-xl p-6 border border-gray-100">
              <div className="flex items-center mb-6">
                <Upload className="w-6 h-6 text-blue-600 mr-3" />
                <h2 className="text-xl font-semibold text-gray-800">
                  1. Upload de Arquivo de Contatos
                </h2>
              </div>
              
              <div className="space-y-4">
                <div 
                  className="border-2 border-dashed border-blue-300 rounded-xl p-8 text-center hover:border-blue-400 transition-colors cursor-pointer bg-blue-50"
                  onClick={() => document.getElementById('fileInput').click()}
                >
                  <FileText className="w-12 h-12 text-blue-500 mx-auto mb-4" />
                  <p className="text-gray-700 font-medium">
                    Clique para selecionar arquivo Excel
                  </p>
                  <p className="text-gray-500 text-sm mt-2">
                    Formatos aceitos: .xlsx
                  </p>
                  <p className="text-gray-400 text-xs mt-2">
                    Colunas esperadas: Nome, Telefone, Email, Mensagem (Exemplo)
                  </p>
                </div>
                
                <div className="flex justify-center">
                  <button
                    onClick={downloadExampleFile}
                    className="bg-gradient-to-r from-green-500 to-emerald-500 text-white px-4 py-2 rounded-lg hover:from-green-600 hover:to-emerald-600 transition-all duration-200 text-sm font-medium flex items-center shadow-md"
                  >
                    <Download className="w-4 h-4 mr-2" />
                    Baixar Arquivo de Exemplo
                  </button>
                </div>
                
                <input
                  id="fileInput"
                  type="file"
                  accept=".xlsx"
                  onChange={handleFileUpload}
                  className="hidden"
                />
                
                {file && (
                  <div className="bg-green-50 border border-green-200 rounded-lg p-4">
                    <div className="flex items-center justify-between">
                      <div className="flex items-center">
                        <CheckCircle className="w-5 h-5 text-green-600 mr-2" />
                        <span className="text-green-800 font-medium">
                          {file.name}
                        </span>
                      </div>
                      <span className="text-green-700 text-sm">{contacts.length} contatos</span>
                    </div>
                  </div>
                )}
                
                {isProcessing && (
                  <div className="text-center py-4">
                    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto"></div>
                    <p className="text-gray-600 mt-2">Processando arquivo...</p>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="xl:col-span-2 flex flex-col space-y-6">
            {contacts.length > 0 && (
              <div className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="bg-white rounded-xl shadow-lg p-4 border border-gray-100">
                    <div className="flex items-center">
                      <Users className="w-8 h-8 text-blue-600 mr-3 flex-shrink-0" />
                      <div>
                        <p className="text-2xl font-bold text-gray-800">{contacts.length}</p>
                        <p className="text-gray-600 text-sm">Total de Contatos</p>
                      </div>
                    </div>
                  </div>
                  
                  <div className="bg-gradient-to-r from-emerald-50 to-green-50 rounded-xl shadow-lg p-4 border-2 border-emerald-200">
                    <div className="flex items-center">
                      <div className="bg-emerald-100 rounded-full p-2 mr-3 flex-shrink-0">
                        <span className="text-emerald-600 font-bold text-lg">C</span>
                      </div>
                      <div className="flex-1 min-w-0">
                        <p className="text-2xl font-bold text-emerald-700 truncate">
                          {contacts.length}
                        </p>
                        <p className="text-emerald-600 text-sm font-medium">Total de Créditos Necessários</p>
                        <p className="text-emerald-500 text-xs">1 crédito por mensagem</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="bg-white rounded-2xl shadow-xl p-6 border border-gray-100">
              <div className="flex items-center mb-6">
                <MessageSquare className="w-6 h-6 text-purple-600 mr-3" />
                <h2 className="text-xl font-semibold text-gray-800">
                  2. Defina sua Mensagem
                </h2>
              </div>
              
              <div className="flex items-center space-x-6 mb-4">
                  <label className="flex items-center cursor-pointer">
                      <input
                          type="radio"
                          name="messageSource"
                          value="custom"
                          checked={messageSource === 'custom'}
                          onChange={() => setMessageSource('custom')}
                          className="form-radio h-5 w-5 text-blue-600"
                      />
                      <span className="ml-2 text-gray-700 font-medium">Mensagem Personalizada</span>
                  </label>
                  <label className="flex items-center cursor-pointer" >
                      <input
                          type="radio"
                          name="messageSource"
                          value="column"
                          checked={messageSource === 'column'}
                          onChange={() => setMessageSource('column')}
                          className="form-radio h-5 w-5 text-blue-600"
                          disabled={contacts.length === 0}
                      />
                      <span className="ml-2 text-gray-700 font-medium">Mensagem da Coluna Excel</span>
                  </label>
              </div>

              {messageSource === 'custom' && (
                <>
                  <textarea
                    value={messageTemplate}
                    onChange={(e) => setMessageTemplate(e.target.value)}
                    placeholder="Digite sua mensagem aqui... Use as variáveis abaixo para personalizar."
                    className="w-full h-32 p-4 border border-gray-300 rounded-xl focus:ring-2 focus:ring-purple-500 focus:border-transparent resize-none"
                    maxLength={500}
                  />
                  <div className="flex flex-wrap items-center justify-between text-gray-500 text-sm">
                      <p className="mb-2 w-full md:w-auto">
                          Variáveis disponíveis: {' '}
                          {availableVariables.length > 0 ? (
                              availableVariables.map((variable, index) => (
                                  <span key={variable} className="inline-block bg-blue-100 text-blue-800 px-2 py-0.5 rounded-full text-xs font-semibold mr-1 mb-1">
                                      {`{${String(variable).toLowerCase()}}`}
                                  </span>
                              ))
                          ) : (
                              <span className="text-gray-400">N/A (carregue um arquivo)</span>
                          )}
                      </p>
                      <p className="mb-2 md:mb-0">
                          {messageTemplate.length}/500 caracteres
                      </p>
                  </div>
                </>
              )}

              {messageSource === 'column' && (
                <div className="relative">
                  <select
                    value={selectedMessageColumn}
                    onChange={(e) => setSelectedMessageColumn(e.target.value)}
                    className="w-full p-3 border border-gray-300 rounded-xl bg-white focus:ring-2 focus:ring-purple-500 focus:border-transparent appearance-none pr-10"
                    disabled={contacts.length === 0}
                  >
                    <option value="">Selecione a coluna que contém a mensagem</option>
                    {availableVariables.map((variable) => (
                      <option key={variable} value={String(variable).toLowerCase()}>
                        {variable}
                      </option>
                    ))}
                  </select>
                  <ChevronDown className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" />
                  <p className="text-gray-500 text-sm mt-2">
                    O conteúdo desta coluna será enviado como a mensagem. Você ainda pode usar outras variáveis do Excel dentro do texto da coluna.
                  </p>
                </div>
              )}

              <div className="relative mt-4">
                <label htmlFor="phoneColumnSelect" className="block text-gray-700 text-sm font-medium mb-2">
                  Coluna do Telefone:
                </label>
                <select
                  id="phoneColumnSelect"
                  value={selectedPhoneColumn}
                  onChange={(e) => setSelectedPhoneColumn(e.target.value)}
                  className="w-full p-3 border border-gray-300 rounded-xl bg-white focus:ring-2 focus:ring-blue-500 focus:border-transparent appearance-none pr-10"
                  disabled={contacts.length === 0}
                >
                  <option value="">Selecione a coluna do telefone</option>
                  {availableVariables.map((variable) => (
                    <option key={variable} value={String(variable).toLowerCase()}>
                      {variable}
                    </option>
                  ))}
                </select>
                <ChevronDown className="absolute right-4 top-1/2 translate-y-1/2 text-gray-400 pointer-events-none" />
                <p className="text-gray-500 text-xs mt-1">
                  Certifique-se de que esta coluna contém números de telefone válidos.
                </p>
              </div>


              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mt-4">
                  <h3 className="text-lg font-semibold text-blue-800 mb-2 flex items-center">
                      <MessageSquare className="w-5 h-5 text-blue-600 mr-2" />
                      3. Pré-visualização da Mensagem
                  </h3>
                  <div className="bg-white p-3 rounded-md border border-gray-200 shadow-inner max-h-40 overflow-y-auto">
                      <p className="text-gray-800 whitespace-pre-wrap" dangerouslySetInnerHTML={{ __html: previewMessage }}>
                      </p>
                  </div>
                  <p className="text-blue-700 text-xs mt-2">
                      *A pré-visualização usa dados do primeiro contato na sua lista.
                  </p>
                  <p className="text-blue-700 text-xs mt-1">
                      *Para formatação WhatsApp (negrito, itálico, tachado), use: *texto*, _texto_, ~texto~. Emojis são suportados.
                  </p>
              </div>
              
            </div>

            <button
              onClick={initiateSending}
              disabled={!contacts.length || !selectedPhoneColumn || (messageSource === 'custom' && !messageTemplate.trim()) || (messageSource === 'column' && !selectedMessageColumn) || sendingStatus === 'sending'}
              className="w-full bg-gradient-to-r from-purple-600 to-blue-600 text-white font-semibold py-3 px-6 rounded-xl hover:from-purple-700 hover:to-blue-700 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center shadow-md hover:shadow-lg mt-6"
            >
              {sendingStatus === 'sending' ? (
                <>
                  <Clock className="w-5 h-5 mr-2 animate-spin" />
                  Enviando... ({Math.round(sendingProgress)}%)
                </>
              ) : (
                <>
                  <Send className="w-5 h-5 mr-2" />
                  Enviar Mensagens
                </>
              )}
            </button>


            {sendingStatus === 'sending' && (
              <div className="bg-white rounded-2xl shadow-xl p-6 border border-gray-100 mt-6">
                <div className="flex items-center mb-4">
                  <TrendingUp className="w-6 h-6 text-blue-600 mr-3" />
                  <h3 className="text-lg font-semibold text-gray-800">Progresso do Envio</h3>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-3 mb-2">
                  <div 
                    className="bg-gradient-to-r from-blue-500 to-purple-500 h-3 rounded-full transition-all duration-300"
                    style={{ width: `${sendingProgress}%` }}
                  ></div>
                </div>
                <p className="text-gray-600 text-sm">{Math.round(sendingProgress)}% concluído</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

// 3. Componente DashboardPage
const DashboardPage = ({ userId }) => {
  const [dashboardData, setDashboardData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const API_URL = 'https://app.n8n.able.tec.br/api/webhook/dashboard';

  useEffect(() => {
    const fetchDashboardData = async () => {
      if (!userId) {
        setLoading(false);
        // Armazena a mensagem de erro como string
        setError("O ID do usuário não foi fornecido. Por favor, certifique-se de que o serviço de autenticação está funcionando corretamente para carregar o dashboard.");
        return;
      }

      setLoading(true);
      setError(null);
      try {
        const response = await fetch(`${API_URL}?id=${userId}`);
        if (!response.ok) {
          throw new Error(`Erro HTTP: ${response.status} ${response.statusText}`);
        }
        const data = await response.json();
        // CORREÇÃO: Garante que dashboardData seja um objeto válido ou null
        setDashboardData(data && typeof data === 'object' && !Array.isArray(data) && Object.keys(data).length > 0 ? data : null);
      } catch (err) {
        console.error("Erro ao buscar dados do dashboard:", err);
        setError(`Falha ao carregar dados do dashboard: ${err.message}. Verifique se o serviço de dashboard está ativo.`);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, [userId]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600 text-lg">Carregando dados do Dashboard...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
        <div className="text-center bg-red-100 border border-red-400 text-red-700 px-6 py-4 rounded-lg shadow-md">
          <AlertCircle className="w-12 h-12 mx-auto mb-3 text-red-500" />
          <p className="font-semibold text-xl">Erro ao carregar Dashboard!</p>
          <p className="text-sm mt-2">{error}</p>
          <p className="text-xs mt-1">Por favor, tente novamente mais tarde ou verifique a URL do serviço.</p>
        </div>
      </div>
    );
  }

  const defaultData = {
    mensagens_enviadas_hoje: 0,
    taxa_sucesso_geral: "0.00",
    creditos_restantes: "0.00",
    custo_total_mensagens_enviadas: "0.00",
    proximos_envios_agendados: 0,
    alertas_notificacoes: [],
    mensagens_por_status: { valido: 0, invalido: 0 }
  };

  const data = dashboardData || defaultData;
  const totalAlerts = data.alertas_notificacoes ? data.alertas_notificacoes.length : 0;
  // Esta linha já estava correta com o encadeamento opcional
  const totalUsers = (data.mensagens_por_status?.valido || 0) + (data.mensagens_por_status?.invalido || 0);


  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-gray-800 mb-2">
            Dashboard do MsgPanel
          </h1>
          <p className="text-gray-500 text-lg">Visão geral e estatísticas rápidas do seu sistema.</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-100">
            <div className="flex items-center mb-4">
              <TrendingUp className="w-8 h-8 text-blue-600 mr-3" />
              <div>
                <p className="text-gray-600 text-sm">Mensagens Enviadas Hoje</p>
                <p className="text-3xl font-bold text-blue-800">{data.mensagens_enviadas_hoje}</p>
              </div>
            </div>
            <p className="text-gray-500 text-xs">Atualizado em tempo real</p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-100">
            <div className="flex items-center mb-4">
              <Users className="w-8 h-8 text-purple-600 mr-3" />
              <div>
                <p className="text-gray-600 text-sm">Total de Mensagens Processadas</p>
                <p className="text-3xl font-bold text-purple-800">{totalUsers}</p>
              </div>
            </div>
            {/* CORREÇÃO: Adicionada verificação de existência para 'data.mensagens_por_status' no JSX */}
            <p className="text-gray-500 text-xs">Mensagens válidas: {data.mensagens_por_status?.valido || 0}, Inválidas: {data.mensagens_por_status?.invalido || 0}</p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-100">
            <div className="flex items-center mb-4">
              <Clock className="w-8 h-8 text-orange-600 mr-3" />
              <div>
                <p className="text-gray-600 text-sm">Próximos Envios Agendados</p>
                <p className="text-3xl font-bold text-orange-800">{data.proximos_envios_agendados || 0}</p>
              </div>
            </div>
            <p className="text-gray-500 text-xs">Total de campanhas programadas</p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-100">
            <div className="flex items-center mb-4">
              <CheckCircle className="w-8 h-8 text-green-600 mr-3" />
              <div>
                <p className="text-gray-600 text-sm">Taxa de Sucesso Geral</p>
                {/* CORREÇÃO AQUI: Removida a multiplicação por 100 */}
                <p className="text-3xl font-bold text-green-800">{(parseFloat(data.taxa_sucesso_geral)).toFixed(2)}%</p>
              </div>
            </div>
            <p className="text-gray-500 text-xs">Média de envio de mensagens</p>
          </div>

          <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-100">
            <div className="flex items-center mb-4">
              <AlertCircle className="w-8 h-8 text-red-600 mr-3" />
              <div>
                <p className="text-gray-600 text-sm">Alertas e Notificações</p>
                <p className="text-3xl font-bold text-red-800">{totalAlerts}</p>
              </div>
            </div>
            <p className="text-gray-500 text-xs">Verifique os problemas recentes</p>
          </div>

          <div className="bg-gradient-to-r from-emerald-50 to-green-50 rounded-xl shadow-lg p-6 border-2 border-emerald-200">
            <div className="flex items-center mb-4">
              <div className="bg-emerald-100 rounded-full p-2 mr-3">
                <span className="text-emerald-600 font-bold text-lg">C</span>
              </div>
              <div>
                <p className="text-emerald-600 text-sm">Créditos Restantes</p>
                <p className="text-3xl font-bold text-emerald-800">
                  {parseFloat(data.creditos_restantes).toFixed(2)}
                </p>
              </div>
            </div>
            <p className="text-emerald-500 text-xs">Saldo disponível para envios</p>
          </div>

        </div>

        <div className="mt-10 text-center">
            <p className="text-gray-500 text-sm italic">
                * Os dados exibidos no Dashboard são exemplos. Para dados reais, será necessária a integração com seu banco de dados ou API de métricas.
            </p>
        </div>
      </div>
    </div>
  );
};

// 4. Componente Relatório de Envio
const SendingReportPage = ({ sendingResults, onClearLog }) => {
  const downloadReport = () => {
    if (typeof XLSX === 'undefined' || typeof saveAs === 'undefined') {
      console.error('As bibliotecas XLSX ou FileSaver não estão carregadas. Por favor, aguarde um momento ou atualize a página.');
      alert('As bibliotecas XLSX ou FileSaver não estão carregadas. Por favor, aguarde um momento ou atualize a página.');
      return;
    }
    const reportData = sendingResults.details.map(item => ({
      ID: item.id,
      Nome: item.name,
      Telefone: item.telefone,
      Status: item.status === 'success' ? 'Enviado' : 'Falhou',
      Mensagem: item.message
    }));
    
    const ws = XLSX.utils.json_to_sheet(reportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Relatório de Envio');
    XLSX.writeFile(wb, 'relatorio-envio-mensagens.xlsx');
  };

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-gray-800 mb-2">
            Relatório de Envio de Mensagens
          </h1>
          <p className="text-gray-500 text-lg">Detalhes e resultados das suas campanhas de envio.</p>
        </div>

        {sendingResults && sendingResults.total > 0 ? (
          <>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
              <div className="bg-blue-50 rounded-xl shadow-lg p-6 border border-blue-200 text-center">
                <p className="text-gray-600 text-sm mb-1">Total de Mensagens</p>
                <p className="text-4xl font-bold text-blue-800">{sendingResults.total}</p>
              </div>

              <div className="bg-green-50 rounded-xl shadow-lg p-6 border border-green-200 text-center">
                <p className="text-gray-600 text-sm mb-1">Enviadas com Sucesso</p>
                <p className="text-4xl font-bold text-green-800">{sendingResults.sent}</p>
              </div>

              <div className={`rounded-xl shadow-lg p-6 border-2 text-center ${
                sendingResults.failed > 0 
                  ? 'bg-red-50 border-red-300' 
                  : 'bg-gray-50 border-gray-200'
              }`}>
                <p className="text-gray-600 text-sm mb-1">Falhas no Envio</p>
                <p className={`text-4xl font-bold ${
                  sendingResults.failed > 0 ? 'text-red-800' : 'text-gray-500'
                }`}>
                  {sendingResults.failed}
                </p>
              </div>
            </div>

            <div className="bg-white rounded-2xl shadow-xl p-6 border border-gray-100">
                <div className="flex items-center justify-between mb-6">
                    <h3 className="text-xl font-semibold text-gray-800 flex items-center">
                        <ClipboardList className="w-6 h-6 mr-3 text-gray-600" />
                        Detalhes do Envio
                    </h3>
                    <div className="flex space-x-3">
                        <button
                            onClick={downloadReport}
                            className="bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition-colors flex items-center shadow-md"
                        >
                            <Download className="w-4 h-4 mr-2" />
                            Baixar Relatório
                        </button>
                        <button
                            onClick={onClearLog}
                            className="bg-gray-200 text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-300 transition-colors flex items-center shadow-sm"
                        >
                            <XCircle className="w-4 h-4 mr-2" />
                            Limpar Log
                        </button>
                    </div>
                </div>
                
                {sendingResults.details && sendingResults.details.length > 0 ? (
                    <div className="overflow-x-auto">
                        <table className="min-w-full bg-white rounded-lg shadow-md overflow-hidden">
                            <thead className="bg-gray-100 border-b border-gray-200">
                                <tr>
                                    <th className="py-3 px-6 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ID</th>
                                    <th className="py-3 px-6 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nome</th>
                                    <th className="py-3 px-6 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Telefone</th>
                                    <th className="py-3 px-6 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                                    <th className="py-3 px-6 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Mensagem/Erro</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-200">
                                {sendingResults.details.map((detail) => (
                                    <tr key={detail.id} className={`${detail.status === 'error' ? 'bg-red-50 hover:bg-red-100' : 'hover:bg-gray-50'}`}>
                                        <td className="py-3 px-6 whitespace-nowrap text-sm font-medium text-gray-900">{detail.id}</td>
                                        <td className="py-3 px-6 whitespace-nowrap text-sm text-gray-700">{detail.name || 'N/A'}</td>
                                        <td className="py-3 px-6 whitespace-nowrap text-sm text-gray-700">{detail.telefone || 'N/A'}</td>
                                        <td className="py-3 px-6 whitespace-nowrap text-sm">
                                            <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                                                detail.status === 'success' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                                            }`}>
                                                {detail.status === 'success' ? 'Sucesso' : 'Falha'}
                                            </span>
                                        </td>
                                        <td className="py-3 px-6 text-sm text-gray-700 max-w-xs truncate" title={detail.message}>{detail.message}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <div className="text-center py-10 text-gray-500">
                        <ClipboardList className="w-16 h-16 mx-auto mb-4" />
                        <p className="text-lg">Nenhum histórico de envio encontrado.</p>
                        <p className="text-sm mt-2">Envie uma campanha de mensagens para ver os resultados aqui.</p>
                    </div>
                )}
            </div>
          </>
        ) : (
            <div className="text-center py-10 text-gray-500 bg-white rounded-2xl shadow-xl p-6 border border-gray-100">
                <ClipboardList className="w-16 h-16 mx-auto mb-4 text-gray-400" />
                <p className="text-lg font-semibold">Nenhum resultado de envio para exibir.</p>
                <p className="text-sm mt-2">Por favor, realize um envio de mensagens para que os resultados apareçam aqui.</p>
            </div>
        )}
      </div>
    </div>
  );
};


// 5. Novo Componente: SettingsPage (Página de Configurações)
const SettingsPage = ({ userId, fetchSessionStatus, sessionStatus, loadingSessionStatus }) => { // Added sessionStatus and loadingSessionStatus props
  const [qrCodeImage, setQrCodeImage] = useState('');
  const [loadingQr, setLoadingQr] = useState(false);
  const [qrError, setQrError] = useState(null);
  // Simplificado para refletir apenas o estado da UI para o QR Code
  const [uiStatus, setUiStatus] = useState('idle'); // 'idle', 'loading_qr', 'qr_displayed', 'error'
  const [countdown, setCountdown] = useState(10); // Timer for session status refresh

  const QR_CODE_API_BASE_URL = 'https://app.n8n.able.tec.br/webhook/msgpanel/qrcode';

  // Effect to manage the countdown timer and trigger session status refresh
  useEffect(() => {
    let timer;
    // Only start the countdown if the user is logged in and we are not currently loading the session status
    if (userId && !loadingSessionStatus) {
      timer = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            // When countdown reaches 0 or 1, reset and trigger a fetch
            fetchSessionStatus(userId); // Request a fresh session status
            return 10; // Reset countdown for the next cycle
          }
          return prev - 1; // Decrement countdown
        });
      }, 1000); // Update every second
    }

    // Cleanup function: clear the interval when the component unmounts
    // or when dependencies change (e.g., user logs out, loading state changes)
    return () => clearInterval(timer);
  }, [userId, loadingSessionStatus, fetchSessionStatus]); // Dependencies: re-run effect if these change

  // Function to fetch QR Code
  const fetchQrCode = useCallback(async () => {
    if (!userId) {
      setQrError("ID do usuário não disponível para gerar o QR Code. Faça login novamente ou verifique a conexão com o serviço de autenticação.");
      setUiStatus('error'); // Define o status da UI como erro
      return;
    }

    setLoadingQr(true);
    setQrError(null);
    setQrCodeImage(''); // Clear previous QR code when starting a new fetch
    setUiStatus('loading_qr'); // Set UI status to loading QR

    try {
      const url = `${QR_CODE_API_BASE_URL}?id=${userId}`;
      console.log('SettingsPage: Fetching QR Code from URL:', url);

      const response = await fetch(url);
      
      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Erro ao buscar QR Code: ${response.status} ${response.statusText}. Detalhes: ${errorText}`);
      }
      
      const contentType = response.headers.get('content-type');
      console.log('SettingsPage: QR Code API Response Content-Type:', contentType);

      if (contentType && contentType.includes('application/json')) {
        const data = await response.json();
        console.log('SettingsPage: QR Code API JSON Response:', data);
        if (data.qrCodeUrl) {
          setQrCodeImage(data.qrCodeUrl);
          setUiStatus('qr_displayed'); // QR Code foi exibido
          fetchSessionStatus(userId); // Trigger session status refresh in App
        } else if (data.data && typeof data.data === 'string' && data.data.startsWith('data:image')) {
          setQrCodeImage(data.data); // Base64 image
          setUiStatus('qr_displayed'); // QR Code foi exibido
          fetchSessionStatus(userId); // Trigger session status refresh in App
        } else {
          throw new Error("Resposta JSON do QR Code não contém URL ou dados de imagem válidos.");
        }
      } else if (contentType && contentType.includes('text/html')) {
        const htmlText = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlText, 'text/html');
        const imgElement = doc.querySelector('img');

        if (imgElement && imgElement.src) {
          setQrCodeImage(imgElement.src);
          setUiStatus('qr_displayed'); // QR Code foi exibido
          fetchSessionStatus(userId); // Trigger session status refresh in App
        } else {
          throw new Error("Não foi possível encontrar a imagem do QR Code no HTML retornado.");
        }
      } else if (contentType && contentType.includes('image/')) {
        setQrCodeImage(response.url); // Use the final URL of the response
        setUiStatus('qr_displayed'); // QR Code foi exibido
        fetchSessionStatus(userId); // Trigger session status refresh in App
      } else {
        const rawResponseText = await response.text();
        console.error("SettingsPage: Unexpected QR Code API response format. Raw content:", rawResponseText);
        throw new Error(`Formato de resposta inesperado da API do QR Code (${contentType || 'desconhecido'}). Conteúdo: ${rawResponseText.substring(0, 100)}...`);
      }

    } catch (error) {
      console.error("SettingsPage: Erro ao buscar QR Code:", error);
      setQrError(`Falha ao carregar QR Code: ${error.message}. Tente novamente ou verifique a URL do serviço.`);
      setUiStatus('error'); // Define o status da UI como erro
    } finally {
      setLoadingQr(false);
    }
  }, [userId, fetchSessionStatus]); // Added fetchSessionStatus to dependencies

  const startSession = async () => {
    await fetchQrCode();
  };

  // Render the error message if userId is not available
  if (qrError && qrError.includes("ID do usuário não disponível")) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
        <div className="text-center bg-yellow-100 border border-yellow-400 text-yellow-700 px-6 py-4 rounded-lg shadow-md">
          <AlertCircle className="w-12 h-12 mx-auto mb-3 text-yellow-500" />
          <p className="font-semibold text-xl">Serviço de Autenticação Necessário!</p>
          <p className="text-sm mt-2">{qrError}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-gray-800 mb-2 flex items-center justify-center">
            <Settings className="w-10 h-10 text-gray-600 mr-3" />
            Configurações da Conta
          </h1>
          <p className="text-gray-500 text-lg">Gerencie as configurações da sua integração de WhatsApp.</p>
        </div>

        {qrError && !qrError.includes("ID do usuário não disponível") && ( // Show general QR errors here
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative mb-4" role="alert">
            <strong className="font-bold">Erro!</strong>
            <span className="block sm:inline ml-2">{qrError}</span>
            <span className="absolute top-0 bottom-0 right-0 px-4 py-3 cursor-pointer" onClick={() => setQrError(null)}>
              <X className="h-6 w-6 text-red-500" />
            </span>
          </div>
        )}

        <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
          <h2 className="text-2xl font-semibold text-gray-800 mb-6 flex items-center">
            <QrCode className="w-6 h-6 text-blue-600 mr-3" />
            Configuração de Sessão WhatsApp
          </h2>
          
          <div className="flex flex-col md:flex-row items-center md:items-start gap-8">
            <div className="flex-1 text-center md:text-left">
              <p className="text-gray-600 mb-4">
                Para conectar sua conta WhatsApp, clique em "Iniciar Sessão" e escaneie o QR Code que aparecerá.
              </p>
              
              <button
                onClick={startSession}
                disabled={loadingQr || !userId} 
                className="bg-gradient-to-r from-blue-600 to-purple-600 text-white font-semibold py-3 px-6 rounded-xl hover:from-blue-700 hover:to-purple-700 transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center shadow-md hover:shadow-lg mx-auto md:mx-0 mb-3"
              >
                {loadingQr ? (
                  <>
                    <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-3"></div>
                    Carregando...
                  </>
                ) : ( 
                  <>
                    <QrCode className="w-5 h-5 mr-3" />
                    Iniciar Sessão
                  </>
                )}
              </button>

              {/* Novo indicador de status da sessão */}
              <div className="mt-4 p-3 rounded-lg flex items-center justify-center text-sm font-medium shadow-sm">
                {loadingSessionStatus ? (
                  <div className="flex items-center text-gray-600">
                    <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-gray-600 mr-2"></div>
                    Verificando status da sessão...
                  </div>
                ) : (
                  <div className={`flex items-center px-4 py-2 rounded-lg border ${sessionStatus === 'WORKING' ? 'bg-green-100 text-green-800 border-green-300' : 'bg-red-100 text-red-800 border-red-300'}`}>
                    <span className={`w-3 h-3 rounded-full mr-2 ${sessionStatus === 'WORKING' ? 'bg-green-500' : 'bg-red-500'}`}></span>
                    <span className="font-semibold">Status da sessão:</span>
                    <span className={`ml-2 font-bold ${sessionStatus === 'WORKING' ? 'text-green-900' : 'text-red-900'}`}>
                      {sessionStatus === 'WORKING' ? 'Ativa e Pronta!' : 'Não Ativa / Aguardando...'}
                    </span>
                    <span className="ml-4 text-gray-600">
                      Próxima verificação em <span className="font-bold">{countdown}</span>s
                    </span>
                    {sessionStatus === 'WORKING' ? (
                      <p className="ml-4 text-green-700 text-xs">
                        Agora você pode retornar à página de Mensagens.
                      </p>
                    ) : (
                      <p className="ml-4 text-red-700 text-xs">
                        Clique em "Iniciar Sessão" e escaneie o QR Code.
                      </p>
                    )}
                  </div>
                )}
              </div>
              
              {/* Texto de instrução movido para cá */}
              {uiStatus === 'qr_displayed' && !loadingQr && !qrError && (
                <p className="text-gray-700 text-sm mt-2">
                  Escaneie o QR Code com seu celular. O QR Code é atualizado periodicamente.
                </p>
              )}

            </div>

            {/* QR Code display area */}
            <div className="w-full md:w-1/2 lg:w-1/3 flex-shrink-0 bg-gray-100 p-6 rounded-xl shadow-inner border border-gray-200 flex flex-col items-center justify-center h-64">
              {loadingQr && ( 
                <div className="text-center">
                  <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-3"></div>
                  <p className="text-gray-600">Gerando QR Code...</p>
                  <p className="text-gray-500 text-sm mt-1">Isso pode levar alguns segundos.</p>
                </div>
              )}
              {qrError && !loadingQr && ( 
                <div className="text-center text-red-700">
                  <AlertCircle className="w-12 h-12 mx-auto mb-3" />
                  <p className="font-semibold">Erro ao carregar QR Code.</p>
                  <p className="text-sm">{qrError}</p>
                </div>
              )}
              {qrCodeImage && !loadingQr && !qrError && uiStatus === 'qr_displayed' && (
                <div className="text-center">
                  <img src={qrCodeImage} alt="QR Code" className="w-48 h-48 mx-auto rounded-lg shadow-md border border-gray-300" />
                </div>
              )}
              {!qrCodeImage && !loadingQr && !qrError && uiStatus === 'idle' && (
                <div className="text-center text-gray-500">
                  <QrCode className="w-12 h-12 mx-auto mb-3" />
                  <p>QR Code aparecerá aqui.</p>
                  <p className="text-sm">Clique em "Iniciar Sessão" para gerar.</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};


// 6. Componente AdminPage
const AdminPage = () => {
  const [adminCurrentTab, setAdminCurrentTab] = useState('users');

  const [users, setUsers] = useState([
    { id: 1, name: 'Alice Smith', email: 'alice@example.com', role: 'user' },
    { id: 2, name: 'Bob Johnson', email: 'bob@example.com', role: 'admin' },
    { id: 3, name: 'Charlie Brown', email: 'charlie@example.com', role: 'user' },
  ]);
  const [editingUser, setEditingUser] = useState(null);
  const [newUser, setNewUser] = useState({ name: '', email: '', role: 'user' });

  const [whatsappSessions, setWhatsappSessions] = useState([
    { id: 'sessao-1', name: 'Principal Marketing', status: 'connected', lastActivity: '2025-06-21 10:30' },
    { id: 'sessao-2', name: 'Suporte Vendas', status: 'disconnected', lastActivity: '2025-06-20 15:00' },
    { id: 'sessao-3', name: 'Notificações', status: 'awaiting_qr', lastActivity: '2025-06-22 09:00', qrCode: 'https://placehold.co/150x150/000000/FFFFFF?text=QR1' },
  ]);

  const [globalLogs, setGlobalLogs] = useState([
    { id: 101, user: 'Alice Smith', recipient: '5511999991111', message: 'Hello {Nome}', status: 'success', timestamp: '2025-06-21 10:30' },
    { id: 102, user: 'Bob Johnson', recipient: '5511988882222', message: 'Promoção para {Produto}', status: 'failed', timestamp: '2025-06-21 11:00' },
    { id: 103, user: 'Charlie Brown', recipient: '5511977773333', message: 'Confirmação do pedido', status: 'success', timestamp: '2025-06-21 11:15' },
    { id: 104, user: 'Bob Johnson', recipient: '5511966664444', message: 'Lembrete de pagamento', status: 'success', timestamp: '2025-06-22 09:00' },
  ]);
  const [logFilter, setLogFilter] = useState('');

  const handleAddOrUpdateUser = () => {
    if (editingUser) {
      setUsers(users.map(u => u.id === editingUser.id ? editingUser : u));
      setEditingUser(null);
    } else {
      setUsers([...users, { ...newUser, id: users.length > 0 ? Math.max(...users.map(u => u.id)) + 1 : 1 }]);
      setNewUser({ name: '', email: '', role: 'user' });
    }
  };

  const handleDeleteUser = (id) => {
    setUsers(users.filter(u => u.id !== id));
  };

  const handleStartNewSession = () => {
    const newSessionId = `sessao-${whatsappSessions.length + 1}`;
    setWhatsappSessions(prev => [
      ...prev,
      { id: newSessionId, name: `Nova Sessão ${newSessionId}`, status: 'connecting', lastActivity: new Date().toLocaleString() }
    ]);
    setTimeout(() => {
        setWhatsappSessions(prev => prev.map(session => 
            session.id === newSessionId 
            ? { ...session, status: 'awaiting_qr', qrCode: `https://placehold.co/150x150/000000/FFFFFF?text=QR${newSessionId.split('-')[1]}` }
            : session
        ));
    }, 2000);
  };

  const handleConnectSession = (sessionId) => {
    setWhatsappSessions(prev => prev.map(session => 
        session.id === sessionId ? { ...session, status: 'connected', qrCode: null, lastActivity: new Date().toLocaleString() } : session
    ));
    alert(`Sessão ${sessionId} marcada como Conectada.`);
  };

  const handleDisconnectSession = (sessionId) => {
    setWhatsappSessions(prev => prev.map(session => 
        session.id === sessionId ? { ...session, status: 'disconnected', qrCode: null, lastActivity: new Date().toLocaleString() } : session
    ));
    alert(`Sessão ${sessionId} marcada como Desconectada.`);
  };

  const filteredGlobalLogs = globalLogs.filter(log => 
    log.user.toLowerCase().includes(logFilter.toLowerCase()) ||
    log.recipient.includes(logFilter) ||
    log.message.toLowerCase().includes(logFilter.toLowerCase()) ||
    log.status.toLowerCase().includes(logFilter.toLowerCase())
  );


  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-gray-800 mb-2 flex items-center justify-center">
            <Settings className="w-10 h-10 text-gray-600 mr-3" />
            Painel Administrativo
          </h1>
          <p className="text-gray-500 text-lg">Gerenciamento de usuários, sessões e logs do sistema.</p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
          <div className="border-b border-gray-200 mb-8">
            <nav className="-mb-px flex space-x-8" aria-label="Tabs">
              <button
                onClick={() => setAdminCurrentTab('users')}
                className={`py-4 px-1 text-center text-sm font-medium border-b-2 ${
                  adminCurrentTab === 'users'
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                Gerenciar Usuários
              </button>
              <button
                onClick={() => setAdminCurrentTab('whatsapp')}
                className={`py-4 px-1 text-center text-sm font-medium border-b-2 ${
                  adminCurrentTab === 'whatsapp'
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                Sessões WhatsApp
              </button>
              <button
                onClick={() => setAdminCurrentTab('global-log')}
                className={`py-4 px-1 text-center text-sm font-medium border-b-2 ${
                  adminCurrentTab === 'global-log'
                    ? 'border-blue-500 text-blue-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-300'
                }`}
              >
                Log de Envios Global
              </button>
            </nav>
          </div>

          {adminCurrentTab === 'users' && (
            <div>
              <h3 className="text-2xl font-semibold text-gray-800 mb-6 flex items-center">
                <Users className="w-6 h-6 text-purple-600 mr-3" />
                Gerenciar Usuários
              </h3>

              <div className="bg-gray-50 p-6 rounded-xl border border-gray-200 mb-8">
                <h4 className="text-xl font-semibold text-gray-700 mb-4">
                  {editingUser ? 'Editar Usuário' : 'Adicionar Novo Usuário'}
                </h4>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <input
                    type="text"
                    placeholder="Nome"
                    className="p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
                    value={editingUser ? editingUser.name : newUser.name}
                    onChange={(e) => editingUser ? setEditingUser({...editingUser, name: e.target.value}) : setNewUser({...newUser, name: e.target.value})}
                  />
                  <input
                    type="email"
                    placeholder="Email"
                    className="p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
                    value={editingUser ? editingUser.email : newUser.email}
                    onChange={(e) => editingUser ? setEditingUser({...editingUser, email: e.target.value}) : setNewUser({...newUser, email: e.target.value})}
                  />
                  <select
                    className="p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
                    value={editingUser ? editingUser.role : newUser.role}
                    onChange={(e) => editingUser ? setEditingUser({...editingUser, role: e.target.value}) : setNewUser({...newUser, role: e.target.value})}
                  >
                    <option value="user">Usuário</option>
                    <option value="admin">Admin</option>
                  </select>
                </div>
                <button
                  onClick={handleAddOrUpdateUser}
                  className="mt-6 bg-blue-600 text-white px-6 py-3 rounded-xl hover:bg-blue-700 transition-colors flex items-center justify-center shadow-md"
                >
                  <PlusCircle className="w-5 h-5 mr-2" />
                  {editingUser ? 'Salvar Edição' : 'Adicionar Usuário'}
                </button>
                {editingUser && (
                    <button
                        onClick={() => setEditingUser(null)}
                        className="mt-6 ml-4 bg-gray-200 text-gray-800 px-6 py-3 rounded-xl hover:bg-gray-300 transition-colors flex items-center justify-center shadow-sm"
                    >
                        <X className="w-5 h-5 mr-2" />
                        Cancelar Edição
                    </button>
                )}
              </div>

              <div className="overflow-x-auto">
                <table className="min-w-full bg-white rounded-lg shadow-md overflow-hidden">
                  <thead className="bg-gray-100 border-b border-gray-200">
                    <tr>
                      <th className="py-3 px-6 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ID</th>
                      <th className="py-3 px-6 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nome</th>
                      <th className="py-3 px-6 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
                      <th className="py-3 px-6 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Perfil</th>
                      <th className="py-3 px-6 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ações</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {users.map(user => (
                      <tr key={user.id} className="hover:bg-gray-50">
                        <td className="py-3 px-6 whitespace-nowrap text-sm font-medium text-gray-900">{user.id}</td>
                        <td className="py-3 px-6 whitespace-nowrap text-sm text-gray-700">{user.name}</td>
                        <td className="py-3 px-6 whitespace-nowrap text-sm text-gray-700">{user.email}</td>
                        <td className="py-3 px-6 whitespace-nowrap text-sm">
                          <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                            user.role === 'admin' ? 'bg-indigo-100 text-indigo-800' : 'bg-gray-100 text-gray-800'
                          }`}>
                            {user.role === 'admin' ? 'Admin' : 'Usuário'}
                          </span>
                        </td>
                        <td className="py-3 px-6 whitespace-nowrap text-sm font-medium">
                          <button onClick={() => setEditingUser(user)} className="text-blue-600 hover:text-blue-900 mr-3">
                            <Edit className="w-5 h-5" />
                          </button>
                          <button onClick={() => handleDeleteUser(user.id)} className="text-red-600 hover:text-red-900">
                            <Trash2 className="w-5 h-5" />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {adminCurrentTab === 'whatsapp' && (
            <div>
              <h3 className="text-2xl font-semibold text-gray-800 mb-6 flex items-center">
                <QrCode className="w-6 h-6 text-blue-600 mr-3" />
                Gerenciar Sessões WhatsApp
              </h3>

              <button
                onClick={handleStartNewSession}
                className="bg-green-600 text-white px-6 py-3 rounded-xl hover:bg-green-700 transition-colors flex items-center justify-center shadow-md mb-8"
              >
                <PlusCircle className="w-5 h-5 mr-2" />
                Iniciar Nova Sessão WAHA
              </button>

              <div className="overflow-x-auto">
                <table className="min-w-full bg-white rounded-lg shadow-md overflow-hidden">
                  <thead className="bg-gray-100 border-b border-gray-200">
                    <tr>
                      <th className="py-3 px-6 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ID da Sessão</th>
                      <th className="py-3 px-6 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Nome</th>
                      <th className="py-3 px-6 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                      <th className="py-3 px-6 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Última Atividade</th>
                      <th className="py-3 px-6 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">QR Code / Ações</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {whatsappSessions.map(session => (
                      <tr key={session.id} className="hover:bg-gray-50">
                        <td className="py-3 px-6 whitespace-nowrap text-sm font-medium text-gray-900">{session.id}</td>
                        <td className="py-3 px-6 whitespace-nowrap text-sm text-gray-700">{session.name}</td>
                        <td className="py-3 px-6 whitespace-nowrap text-sm">
                          <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                            session.status === 'connected' ? 'bg-green-100 text-green-800' :
                            session.status === 'disconnected' ? 'bg-red-100 text-red-800' :
                            'bg-yellow-100 text-yellow-800'
                          }`}>
                            {session.status === 'connected' ? 'Conectado' :
                             session.status === 'disconnected' ? 'Desconectado' :
                             session.status === 'connecting' ? 'Conectando...' : 'Aguardando QR'}
                          </span>
                        </td>
                        <td className="py-3 px-6 whitespace-nowrap text-sm text-gray-700">{session.lastActivity}</td>
                        <td className="py-3 px-6 whitespace-nowrap text-sm font-medium">
                            {session.status === 'awaiting_qr' && session.qrCode ? (
                                <div className="flex items-center">
                                    <img src={session.qrCode} alt="QR Code" className="w-16 h-16 mr-3 border rounded-lg" />
                                    <button onClick={() => handleConnectSession(session.id)} className="text-green-600 hover:text-green-900 flex items-center">
                                        <Wifi className="w-5 h-5 mr-1" /> Marcar Conectada
                                    </button>
                                </div>
                            ) : session.status === 'connected' ? (
                                <button onClick={() => handleDisconnectSession(session.id)} className="text-red-600 hover:text-red-900 flex items-center">
                                    <WifiOff className="w-5 h-5 mr-1" /> Desconectar
                                </button>
                            ) : session.status === 'disconnected' ? (
                                <button onClick={() => handleStartNewSession(session.id)} className="text-blue-600 hover:text-blue-900 flex items-center">
                                    <Wifi className="w-5 h-5 mr-1" /> Reconectar
                                </button>
                            ) : (
                                <span className="text-gray-500">N/A</span>
                            )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

          {adminCurrentTab === 'global-log' && (
            <div>
              <h3 className="text-2xl font-semibold text-gray-800 mb-6 flex items-center">
                <ListFilter className="w-6 h-6 text-orange-600 mr-3" />
                Log de Envios Global
              </h3>

              <div className="mb-6">
                <input
                  type="text"
                  placeholder="Filtrar por usuário, telefone, mensagem ou status..."
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500"
                  value={logFilter}
                  onChange={(e) => setLogFilter(e.target.value)}
                />
              </div>

              <div className="overflow-x-auto">
                <table className="min-w-full bg-white rounded-lg shadow-md overflow-hidden">
                  <thead className="bg-gray-100 border-b border-gray-200">
                    <tr>
                      <th className="py-3 px-6 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ID</th>
                      <th className="py-3 px-6 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Usuário</th>
                      <th className="py-3 px-6 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Destinatário</th>
                      <th className="py-3 px-6 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Mensagem</th>
                      <th className="py-3 px-6 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                      <th className="py-3 px-6 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Data/Hora</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {filteredGlobalLogs.map(log => (
                      <tr key={log.id} className={`${log.status === 'failed' ? 'bg-red-50 hover:bg-red-100' : 'hover:bg-gray-50'}`}>
                        <td className="py-3 px-6 whitespace-nowrap text-sm font-medium text-gray-900">{log.id}</td>
                        <td className="py-3 px-6 whitespace-nowrap text-sm text-gray-700">{log.user}</td>
                        <td className="py-3 px-6 whitespace-nowrap text-sm text-gray-700">{log.recipient}</td>
                        <td className="py-3 px-6 text-sm text-gray-700 max-w-xs truncate" title={log.message}>{log.message}</td>
                        <td className="py-3 px-6 whitespace-nowrap text-sm">
                          <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                            log.status === 'success' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                          }`}>
                            {log.status === 'success' ? 'Sucesso' : 'Falha'}
                          </span>
                        </td>
                        <td className="py-3 px-6 whitespace-nowrap text-sm text-gray-700">{log.timestamp}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

// 7. Componente: NotificationsPage (Página de Notificações)
const NotificationsPage = ({ userId }) => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null); // Alterado para null para consistência

  const API_URL = 'https://app.n8n.able.tec.br/api/webhook/msgpanel/notificafalha';

  useEffect(() => {
    const fetchNotifications = async () => {
      if (!userId) {
        setLoading(false);
        // Armazena a mensagem de erro como string
        setError("ID do usuário não disponível para carregar as notificações. Por favor, faça login ou verifique a conexão com o serviço de autenticação.");
        return;
      }

      setLoading(true);
      setError(null); // Limpa o erro ao iniciar nova busca
      try {
        const response = await fetch(`${API_URL}?id=${userId}`);
        if (!response.ok) {
          throw new Error(`Erro HTTP: ${response.status} ${response.statusText}`);
        }
        
        // CORREÇÃO: Verifica se a resposta não está vazia antes de tentar parsear como JSON
        const responseText = await response.text();
        if (!responseText) {
          console.warn("Resposta vazia da API de notificações. Assumindo sem notificações.");
          setNotifications([]);
          setLoading(false);
          return;
        }

        let data;
        try {
          data = JSON.parse(responseText);
        } catch (jsonError) {
          console.error("Erro ao parsear JSON da API de notificações:", jsonError);
          throw new Error(`Resposta inválida da API de notificações. Não é um JSON válido. Detalhes: ${jsonError.message}`);
        }
        
        setNotifications(data);
      } catch (err) {
        console.error("Erro ao buscar notificações:", err);
        setError(`Falha ao carregar notificações: ${err.message}. Verifique se o serviço de notificações está ativo.`);
      } finally {
        setLoading(false);
      }
    };

    fetchNotifications();
  }, [userId]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600 text-lg">Carregando notificações...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
        <div className="text-center bg-red-100 border border-red-400 text-red-700 px-6 py-4 rounded-lg shadow-md">
          <AlertCircle className="w-12 h-12 mx-auto mb-3 text-red-500" />
          <p className="font-semibold text-xl">Erro ao carregar Notificações!</p>
          <p className="text-sm mt-2">{error}</p>
          <p className="text-xs mt-1">Por favor, tente novamente mais tarde ou verifique a URL do serviço.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-gray-800 mb-2 flex items-center justify-center">
            <Bell className="w-10 h-10 text-orange-600 mr-3" />
            Notificações
          </h1>
          <p className="text-gray-500 text-lg">Alertas e eventos importantes do sistema.</p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-6 border border-gray-100">
          <h3 className="text-xl font-semibold text-gray-800 mb-6 flex items-center">
            <ClipboardList className="w-6 h-6 mr-3 text-gray-600" />
            Detalhes das Notificações
          </h3>
          
          {notifications.length > 0 ? (
            <div className="overflow-x-auto">
              <table className="min-w-full bg-white rounded-lg shadow-md overflow-hidden">
                <thead className="bg-gray-100 border-b border-gray-200">
                  <tr>
                    <th className="py-3 px-6 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Data/Hora</th>
                    <th className="py-3 px-6 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ação</th>
                    <th className="py-3 px-6 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Descrição</th>
                    <th className="py-3 px-6 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Destinatário</th>
                    <th className="py-3 px-6 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Mensagem Resumo</th>
                    <th className="py-3 px-6 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Motivo Status</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {notifications.map((notification) => (
                    <tr key={notification.log_id} className="hover:bg-gray-50">
                      <td className="py-3 px-6 whitespace-nowrap text-sm font-medium text-gray-900">{notification.data_operacao}</td>
                      <td className="py-3 px-6 whitespace-nowrap text-sm text-gray-700">
                        <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                          notification.acao === 'invalido' ? 'bg-red-100 text-red-800' :
                          notification.acao === 'validando' ? 'bg-yellow-100 text-yellow-800' :
                          'bg-blue-100 text-blue-800'
                        }`}>
                          {notification.acao}
                        </span>
                      </td>
                      <td className="py-3 px-6 text-sm text-gray-700 max-w-xs truncate" title={notification.descricao}>{notification.descricao}</td>
                      <td className="py-3 px-6 whitespace-nowrap text-sm text-gray-700">{notification.destinatario}</td>
                      <td className="py-3 px-6 text-sm text-gray-700 max-w-xs truncate" title={notification.mensagem_resumo}>{notification.mensagem_resumo}</td>
                      <td className="py-3 px-6 text-sm text-gray-700 max-w-xs truncate" title={notification.mensagem_motivo_status}>{notification.mensagem_motivo_status}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="text-center py-10 text-gray-500">
              <Bell className="w-16 h-16 mx-auto mb-4 text-gray-400" />
              <p className="text-lg font-semibold">Nenhuma notificação encontrada.</p>
              <p className="text-sm mt-2">Verifique novamente mais tarde ou ajuste suas configurações de alerta.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

// 8. Novo Componente: OperationsLogPage (Log Completo das Operações)
const OperationsLogPage = ({ userId }) => {
  const [operationsLog, setOperationsLog] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null); // Alterado para null para consistência
  const [expandedMessageId, setExpandedMessageId] = useState(null); // FIX: Changed to useState(null)

  const API_URL = 'https://app.n8n.able.tec.br/api/webhook/msgpanel/log';

  useEffect(() => {
    const fetchOperationsLog = async () => {
      if (!userId) {
        setLoading(false);
        // Armazena a mensagem de erro como string
        setError("ID do usuário não disponível para carregar o log de operações. Por favor, faça login ou verifique a conexão com o serviço de autenticação.");
        return;
      }

      setLoading(true);
      setError(null); // Limpa o erro ao iniciar nova busca
      try {
        const url = `${API_URL}?id=${userId}`;
        console.log('OperationsLogPage: Fetching Operations Log from URL:', url); // Log da URL completa

        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`Erro HTTP: ${response.status} ${response.statusText}`);
        }
        
        const responseText = await response.text();
        console.log('OperationsLogPage: Raw API response for Operations Log:', responseText); // Log da resposta bruta
        
        if (!responseText) {
          console.warn("OperationsLogPage: Resposta vazia da API de log de operações. Assumindo sem logs.");
          setOperationsLog([]);
          setLoading(false);
          return;
        }

        let data;
        try {
          data = JSON.parse(responseText);
          console.log('OperationsLogPage: Parsed JSON data for Operations Log:', data); // Log dos dados parseados
          console.log('OperationsLogPage: Number of items received for Operations Log:', data.length); // Log da quantidade de itens
        } catch (jsonError) {
          console.error("OperationsLogPage: Erro ao parsear JSON da API de log de operações:", jsonError);
          throw new Error(`Resposta inválida da API de log de operações. Não é um JSON válido. Detalhes: ${jsonError.message}`);
        }

        setOperationsLog(data);
      } catch (err) {
        console.error("OperationsLogPage: Erro ao buscar log de operações:", err);
        setError(`Falha ao carregar log de operações: ${err.message}. Verifique se o serviço de log está ativo.`);
      } finally {
        setLoading(false);
      }
    };

    fetchOperationsLog();
  }, [userId]);

  // Agrupa os logs por mensagem_id
  const groupedLogs = operationsLog.reduce((acc, log) => {
    const messageId = log.mensagem_id;
    if (!acc[messageId]) {
      acc[messageId] = [];
    }
    acc[messageId].push(log);
    return acc;
  }, {});

  // Ordena as chaves (messageId) em ordem decrescente
  const sortedMessageIds = Object.keys(groupedLogs).sort((a, b) => {
    // Converte os IDs de mensagem para números para comparação numérica
    const numA = parseInt(a, 10);
    const numB = parseInt(b, 10);
    // Ordena em ordem decrescente (maior ID de Mensagem primeiro)
    return numB - numA;
  });

  console.log('OperationsLogPage: Final sorted Message IDs:', sortedMessageIds);


  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600 text-lg">Carregando Log de Operações...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
        <div className="text-center bg-red-100 border border-red-400 text-red-700 px-6 py-4 rounded-lg shadow-md">
          <AlertCircle className="w-12 h-12 mx-auto mb-3 text-red-500" />
          <p className="font-semibold text-xl">Erro ao carregar Log de Operações!</p>
          <p className="text-sm mt-2">{error}</p>
          <p className="text-xs mt-1">Por favor, tente novamente mais tarde ou verifique a URL do serviço.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-gray-800 mb-2 flex items-center justify-center">
            <Activity className="w-10 h-10 text-blue-600 mr-3" />
            Log Completo de Operações
          </h1>
          <p className="text-gray-500 text-lg">Registro detalhado de todas as atividades do sistema.</p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-6 border border-gray-100">
          <h3 className="text-xl font-semibold text-gray-800 mb-6 flex items-center">
            <ClipboardList className="w-6 h-6 mr-3 text-gray-600" />
            Eventos Recentes por Mensagem
          </h3>
          <p className="text-gray-600 text-sm mb-4">
            Os logs são agrupados por ID da Mensagem. Clique em uma linha para expandir e ver todos os detalhes das operações relacionadas a essa mensagem.
          </p>
          
          {sortedMessageIds.length > 0 ? (
            <div className="space-y-6">
              {sortedMessageIds.map((messageId) => {
                // Sort logs within the current group by data_operacao (descending) and then log_id (descending)
                const sortedLogsInGroup = groupedLogs[messageId].sort((a, b) => {
                  const dateA = new Date(a.data_operacao);
                  const dateB = new Date(b.data_operacao);
                  if (dateA.getTime() !== dateB.getTime()) {
                    return dateB.getTime() - dateA.getTime(); // Newest first
                  }
                  return b.log_id - a.log_id; // Higher log_id first for tie-breaking
                });
                
                // Use the latest log (which is the first after sorting) for the summary display
                const latestLogOfGroup = sortedLogsInGroup[0];
                console.log(`OperationsLogPage: Rendering Message ID: ${messageId}. Latest log for summary:`, latestLogOfGroup);

                return (
                  <div key={messageId} className="bg-gray-50 rounded-xl shadow-md p-4 border border-gray-200">
                    <div
                      className="flex items-center justify-between cursor-pointer py-2"
                      onClick={() => setExpandedMessageId(expandedMessageId === messageId ? null : messageId)}
                    >
                      <h4 className="text-lg font-semibold text-gray-800 flex items-center">
                        <MessageSquare className="w-5 h-5 mr-2 text-blue-500" />
                        Mensagem ID: <span className="font-bold ml-1">{messageId}</span>
                        <span className="ml-4 text-gray-600 text-base">
                          Destinatário: {latestLogOfGroup.destinatario}
                        </span>
                        <span className="ml-4 text-gray-500 text-sm italic max-w-xs truncate">
                          ({latestLogOfGroup.mensagem_resumo})
                        </span>
                      </h4>
                      {expandedMessageId === messageId ? (
                        <ChevronUp className="w-5 h-5 text-gray-500" />
                      ) : (
                        <ChevronDown className="w-5 h-5 text-gray-500" />
                      )}
                    </div>

                    {expandedMessageId === messageId && (
                      <div className="mt-4 overflow-x-auto border-t border-gray-200 pt-4">
                        <table className="min-w-full bg-white rounded-lg shadow-inner overflow-hidden">
                          <thead className="bg-gray-100 border-b border-gray-200">
                            <tr>
                              <th className="py-2 px-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ID Log</th>
                              <th className="py-2 px-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Data/Hora</th>
                              <th className="py-2 px-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Usuário</th>
                              <th className="py-2 px-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Ação</th>
                              <th className="py-2 px-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Descrição</th>
                              <th className="py-2 px-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Motivo Status</th>
                              <th className="py-2 px-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Origem</th>
                              <th className="py-2 px-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Dados</th>
                            </tr>
                          </thead>
                          <tbody className="divide-y divide-gray-200">
                            {sortedLogsInGroup.map((log) => ( // Use the already sorted logs for rendering
                              <tr key={log.log_id} className="hover:bg-gray-50">
                                <td className="py-2 px-4 whitespace-nowrap text-sm font-medium text-gray-900">{log.log_id}</td>
                                <td className="py-2 px-4 whitespace-nowrap text-sm text-gray-700">{log.data_operacao}</td>
                                <td className="py-2 px-4 whitespace-nowrap text-sm text-gray-700">{log.usuario_nome} ({log.usuario_email})</td>
                                <td className="py-2 px-4 whitespace-nowrap text-sm">
                                  <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                                    log.acao === 'validado' ? 'bg-green-100 text-green-800' :
                                    log.acao === 'invalido' ? 'bg-red-100 text-red-800' :
                                    'bg-blue-100 text-blue-800'
                                  }`}>
                                    {log.acao}
                                  </span>
                                </td>
                                <td className="py-2 px-4 text-sm text-gray-700 max-w-lg" title={log.descricao}>{log.descricao}</td>
                                <td className="py-2 px-4 text-sm text-gray-700 max-w-lg" title={log.mensagem_motivo_status}>{log.mensagem_motivo_status}</td>
                                <td className="py-2 px-4 whitespace-nowrap text-sm text-gray-700">{log.origem}</td>
                                <td className="py-2 px-4 text-sm text-gray-700 max-w-md" title={JSON.stringify(log.dados)}>{JSON.stringify(log.dados)}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="text-center py-10 text-gray-500">
              <Activity className="w-16 h-16 mx-auto mb-4 text-gray-400" />
              <p className="text-lg font-semibold">Nenhum log de operações encontrado.</p>
              <p className="text-sm mt-2">O log de operações será preenchido conforme as atividades do sistema ocorrem. Se você espera ver mais dados aqui, por favor, verifique a API de backend, pois o problema pode estar na origem dos dados.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

// 9. Novo Componente: ReportsPage (Página de Relatórios)
const ReportsPage = ({ userId }) => {
  const [reportsData, setReportsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const API_URL = 'https://app.n8n.able.tec.br/api/webhook/relatorios-visuais';

  useEffect(() => {
    const fetchReportsData = async () => {
      if (!userId) {
        setLoading(false);
        setError("ID do usuário não disponível para carregar os relatórios. Por favor, faça login ou verifique a conexão com o serviço de autenticação.");
        return;
      }

      setLoading(true);
      setError(null);
      try {
        const response = await fetch(`${API_URL}?id=${userId}`);
        if (!response.ok) {
          throw new Error(`Erro HTTP: ${response.status} ${response.statusText}`);
        }
        const data = await response.json();
        // A API retorna um array, mas esperamos um único objeto com os dados
        setReportsData(data[0] || null); 
      } catch (err) {
        console.error("Erro ao buscar dados dos relatórios:", err);
        setError(`Falha ao carregar dados dos relatórios: ${err.message}. Verifique se o serviço de relatórios está ativo.`);
      } finally {
        setLoading(false);
      }
    };

    fetchReportsData();
  }, [userId]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600 text-lg">Carregando Relatórios...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
        <div className="text-center bg-red-100 border border-red-400 text-red-700 px-6 py-4 rounded-lg shadow-md">
          <AlertCircle className="w-12 h-12 mx-auto mb-3 text-red-500" />
          <p className="font-semibold text-xl">Erro ao carregar Relatórios!</p>
          <p className="text-sm mt-2">{error}</p>
          <p className="text-xs mt-1">Por favor, tente novamente mais tarde ou verifique a URL do serviço.</p>
        </div>
      </div>
    );
  }

  if (!reportsData) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
        <div className="text-center bg-yellow-100 border border-yellow-400 text-yellow-700 px-6 py-4 rounded-lg shadow-md">
          <BarChart3 className="w-12 h-12 mx-auto mb-3 text-yellow-500" />
          <p className="font-semibold text-xl">Dados de Relatório Não Disponíveis!</p>
          <p className="text-sm mt-2">Não foi possível carregar os dados dos relatórios. Verifique a URL do serviço e se há dados para o seu usuário.</p>
        </div>
      </div>
    );
  }

  // Preparar dados para os gráficos
  const mensagensEnviadasData = reportsData.mensagens_enviadas_por_dia || [];
  const consumoCreditoData = reportsData.consumo_credito_ao_longo_do_tempo || [];
  const distribuicaoStatusData = reportsData.distribuicao_mensagens_por_status 
    ? Object.keys(reportsData.distribuicao_mensagens_por_status).map(key => ({
        name: key.charAt(0).toUpperCase() + key.slice(1), // Capitaliza a primeira letra
        value: reportsData.distribuicao_mensagens_por_status[key]
      }))
    : [];

  const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#AF19FF']; // Cores para o gráfico de pizza

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-gray-800 mb-2 flex items-center justify-center">
            <BarChart3 className="w-10 h-10 text-blue-600 mr-3" />
            Relatórios Visuais
          </h1>
          <p className="text-gray-500 text-lg">Análise gráfica das suas operações de mensagens.</p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Gráfico 1: Mensagens Enviadas por Dia */}
          <div className="bg-white rounded-2xl shadow-xl p-6 border border-gray-100">
            <h3 className="text-xl font-semibold text-gray-800 mb-4">Mensagens Enviadas por Dia (Tendência Diária)</h3>
            {mensagensEnviadasData.length > 0 ? (
              <ResponsiveContainer width="100%" height={300}>
                <LineChart data={mensagensEnviadasData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="data" /> {/* Assumindo que a chave para data é 'data' */}
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  <Line type="monotone" dataKey="quantidade" stroke="#8884d8" activeDot={{ r: 8 }} /> {/* Assumindo 'quantidade' para o valor */}
                </LineChart>
              </ResponsiveContainer>
            ) : (
              <div className="text-center py-10 text-gray-500">
                <BarChart3 className="w-16 h-16 mx-auto mb-4" />
                <p>Nenhum dado para "Mensagens Enviadas por Dia".</p>
                <p className="text-sm mt-2">Este gráfico requer dados de mensagens enviadas diariamente.</p>
              </div>
            )}
          </div>

          {/* Gráfico 2: Distribuição de Mensagens por Status */}
          <div className="bg-white rounded-2xl shadow-xl p-6 border border-gray-100">
            <h3 className="text-xl font-semibold text-gray-800 mb-4">Distribuição de Mensagens por Status</h3>
            {distribuicaoStatusData.length > 0 ? (
              <ResponsiveContainer width="100%" height={300}>
                <PieChart>
                  <Pie
                    data={distribuicaoStatusData}
                    cx="50%"
                    cy="50%"
                    labelLine={false}
                    outerRadius={80}
                    fill="#8884d8"
                    dataKey="value"
                    label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                  >
                    {distribuicaoStatusData.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                    ))}
                  </Pie>
                  <Tooltip />
                  <Legend />
                </PieChart>
              </ResponsiveContainer>
            ) : (
              <div className="text-center py-10 text-gray-500">
                <BarChart3 className="w-16 h-16 mx-auto mb-4" />
                <p>Nenhum dado para "Distribuição de Mensagens por Status".</p>
                <p className="text-sm mt-2">Este gráfico requer dados de status de mensagens (válido/inválido).</p>
              </div>
            )}
          </div>

          {/* Gráfico 3: Consumo de Crédito ao Longo do Tempo */}
          <div className="bg-white rounded-2xl shadow-xl p-6 border border-gray-100 lg:col-span-2">
            <h3 className="text-xl font-semibold text-gray-800 mb-4">Consumo de Crédito ao Longo do Tempo (Tendência)</h3>
            {consumoCreditoData.length > 0 ? (
              <ResponsiveContainer width="100%" height={300}>
                <LineChart data={consumoCreditoData} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="data" /> {/* Assumindo 'data' para a chave de data */}
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  <Line type="monotone" dataKey="valor" stroke="#82ca9d" activeDot={{ r: 8 }} /> {/* Assumindo 'valor' para o consumo */}
                </LineChart>
              </ResponsiveContainer>
            ) : (
              <div className="text-center py-10 text-gray-500">
                <BarChart3 className="w-16 h-16 mx-auto mb-4" />
                <p>Nenhum dado para "Consumo de Crédito ao Longo do Tempo".</p>
                <p className="text-sm mt-2">Este gráfico requer dados de consumo de crédito diário.</p>
              </div>
            )}
          </div>
        </div>

        <div className="mt-10 text-center">
            <p className="text-gray-500 text-sm italic">
                * Os dados exibidos nos relatórios dependem da disponibilidade do serviço externo.
            </p>
        </div>
      </div>
    </div>
  );
};


// 10. Novo Componente: HelpPage (Página de Ajuda)
const HelpPage = () => {
  const sections = [
    {
      title: "Visão Geral do Sistema",
      icon: <HelpCircle className="w-6 h-6 text-blue-600 mr-3" />,
      content: (
        <>
          <p className="text-gray-700 mb-2">
            O <strong>MsgPanel</strong> é uma plataforma completa para gerenciamento e envio de mensagens em massa via WhatsApp. Com ele, você pode automatizar suas campanhas, monitorar o desempenho e manter-se conectado com seus contatos de forma eficiente.
          </p>
          <p className="text-gray-700">
            Nosso objetivo é simplificar a comunicação em larga escala, oferecendo ferramentas intuitivas para que você possa focar no que realmente importa: sua mensagem.
          </p>
          <h4 className="text-lg font-semibold text-gray-800 mt-4 mb-2">Exemplo de Uso Real:</h4>
          <p className="text-gray-600 italic">
            "Uma empresa de e-commerce utiliza o MsgPanel para enviar notificações de status de pedidos e promoções personalizadas para milhares de clientes, economizando tempo e aumentando o engajamento."
          </p>
        </>
      ),
    },
    {
      title: "Dashboard",
      icon: <Home className="w-6 h-6 text-green-600 mr-3" />,
      content: (
        <>
          <p className="text-gray-700 mb-2">
            O Dashboard oferece uma visão geral rápida e em tempo real das suas operações. Aqui você encontra métricas importantes como mensagens enviadas hoje, taxa de sucesso, créditos restantes e alertas.
          </p>
          <p className="text-gray-700">
            É o seu painel de controle para acompanhar o pulso das suas campanhas e identificar rapidamente qualquer anomalia.
          </p>
          <h4 className="text-lg font-semibold text-gray-800 mt-4 mb-2">Exemplo de Uso Real:</h4>
          <p className="text-gray-600 italic">
            "Ao abrir o sistema pela manhã, o gerente de marketing verifica o Dashboard para ver quantas mensagens foram enviadas na última noite e se há algum alerta de falha no envio, garantindo que as operações estão funcionando perfeitamente."
          </p>
        </>
      ),
    },
    {
      title: "Envio de Mensagens",
      icon: <MessageSquare className="w-6 h-6 text-purple-600 mr-3" />,
      content: (
        <>
          <p className="text-gray-700 mb-2">
            Nesta seção, você pode carregar uma lista de contatos (arquivo Excel) e definir a mensagem a ser enviada. É possível personalizar a mensagem usando variáveis do próprio Excel ou criar um texto único para todos.
          </p>
          <ul className="list-disc list-inside text-gray-700 ml-4 mb-2">
            <li><strong>Upload de Arquivo de Contatos:</strong> Carregue um arquivo .xlsx com colunas como "Nome", "Telefone", "Email", "Mensagem", etc.</li>
            <li><strong>Defina sua Mensagem:</strong> Escolha entre uma mensagem personalizada (digitada por você) ou usar o conteúdo de uma coluna específica do Excel.</li>
            <li><strong>Variáveis:</strong> Use <code>{`{nome_da_coluna}`}</code> na sua mensagem para inserir dados dinâmicos de cada contato.</li>
            <li><strong>Pré-visualização:</strong> Veja como a mensagem aparecerá para o primeiro contato da sua lista antes de enviar.</li>
          </ul>
          <h4 className="text-lg font-semibold text-gray-800 mt-4 mb-2">Exemplo de Uso Real:</h4>
          <p className="text-gray-600 italic">
            "Um consultor financeiro prepara uma planilha com seus clientes e uma coluna 'Dica_Semanal'. Ele carrega a planilha, seleciona a coluna 'Telefone' e a coluna 'Dica_Semanal' como mensagem, e envia dicas personalizadas para cada cliente automaticamente."
          </p>
        </>
      ),
    },
    {
      title: "Relatório de Envio",
      icon: <ClipboardList className="w-6 h-6 text-orange-600 mr-3" />,
      content: (
        <>
          <p className="text-gray-700 mb-2">
            Após um envio de mensagens, esta página exibe um resumo detalhado dos resultados: total de mensagens, quantas foram enviadas com sucesso e quantas falharam. Você pode baixar um relatório completo em Excel para análise posterior.
          </p>
          <h4 className="text-lg font-semibold text-gray-800 mt-4 mb-2">Exemplo de Uso Real:</h4>
          <p className="text-gray-600 italic">
            "Uma equipe de suporte ao cliente envia uma pesquisa de satisfação pós-atendimento. Eles acessam o Relatório de Envio para confirmar que todas as mensagens foram entregues e identificar rapidamente quais contatos não receberam a pesquisa para um acompanhamento manual."
          </p>
        </>
      ),
    },
    {
      title: "Relatórios Visuais",
      icon: <BarChart3 className="w-6 h-6 text-blue-600 mr-3" />,
      content: (
        <>
          <p className="text-gray-700 mb-2">
            Obtenha insights valiosos sobre suas campanhas através de gráficos interativos. Esta seção apresenta visualizações como mensagens enviadas por dia, distribuição de mensagens por status (válidas/inválidas) e consumo de crédito ao longo do tempo.
          </p>
          <h4 className="text-lg font-semibold text-gray-800 mt-4 mb-2">Exemplo de Uso Real:</h4>
          <p className="text-gray-600 italic">
            "O analista de dados da empresa utiliza os Relatórios Visuais para identificar tendências de envio, como picos de atividade em determinados dias da semana, e para otimizar o orçamento acompanhando o consumo de créditos de forma gráfica."
          </p>
        </>
      ),
    },
    {
      title: "Configurações de Sessão WhatsApp",
      icon: <QrCode className="w-6 h-6 text-teal-600 mr-3" />,
      content: (
        <>
          <p className="text-gray-700 mb-2">
            Aqui você gerencia a conexão da sua conta WhatsApp com o MsgPanel. Para começar a enviar mensagens, você precisará iniciar uma sessão e escanear um QR Code com seu celular, similar ao WhatsApp Web.
          </p>
          <ul className="list-disc list-inside text-gray-700 ml-4 mb-2">
            <li>Clique em "Iniciar Sessão" para gerar um QR Code.</li>
            <li>Use seu aplicativo WhatsApp no celular para escanear o QR Code.</li>
            {/* Removido o item de monitoramento de status da sessão */}
            {/* <li>Monitore o status da sua sessão (conectado, desconectado, aguardando QR).</li> */}
          </ul>
          <h4 className="text-lg font-semibold text-gray-800 mt-4 mb-2">Exemplo de Uso Real:</h4>
          <p className="text-gray-600 italic">
            "Um novo funcionário é encarregado de gerenciar as campanhas. Ele vai até as Configurações, clica em 'Iniciar Sessão' e escaneia o QR Code com o WhatsApp da empresa, ativando a integração para começar os envios."
          </p>
        </>
      ),
    },
    {
      title: "Notificações",
      icon: <Bell className="w-6 h-6 text-red-600 mr-3" />,
      content: (
        <>
          <p className="text-gray-700 mb-2">
            Esta seção exibe alertas e notificações importantes do sistema, como falhas no envio de mensagens ou problemas de conexão. É fundamental verificar esta página regularmente para garantir que suas operações estão saudáveis.
          </p>
          <h4 className="text-lg font-semibold text-gray-800 mt-4 mb-2">Exemplo de Uso Real:</h4>
          <p className="text-gray-600 italic">
            "O administrador do sistema recebe uma notificação de que várias mensagens para um determinado prefixo de telefone falharam. Ele acessa a página de Notificações para ver os detalhes e investigar se há um problema com a operadora ou com a formatação dos números."
          </p>
        </>
      ),
    },
    {
      title: "Log Completo de Operações",
      icon: <Activity className="w-6 h-6 text-indigo-600 mr-3" />,
      content: (
        <>
          <p className="text-gray-700 mb-2">
            Para uma análise aprofundada, o Log Completo de Operações registra cada etapa e evento do sistema, agrupado por ID da Mensagem. Isso é ideal para depuração e auditoria.
          </p>
          <ul className="list-disc list-inside text-gray-700 ml-4 mb-2">
            <li>Visualize o histórico de cada mensagem, desde a validação até o status final.</li>
            <li>Expanda cada grupo de logs para ver todos os detalhes das operações relacionadas.</li>
            <li>Útil para identificar a causa raiz de problemas específicos.</li>
          </ul>
          <h4 className="text-lg font-semibold text-gray-800 mt-4 mb-2">Exemplo de Uso Real:</h4>
          <p className="text-gray-600 italic">
            "Um desenvolvedor precisa entender por que uma mensagem específica não foi entregue. Ele consulta o Log Completo de Operações, filtra pelo ID da mensagem e analisa a sequência de eventos para encontrar o ponto exato da falha, como um erro de validação de número."
          </p>
        </>
      ),
    },
    {
      title: "Administração (Apenas para Administradores)",
      icon: <Users className="w-6 h-6 text-gray-600 mr-3" />,
      content: (
        <>
          <p className="text-gray-700 mb-2">
            Esta seção é exclusiva para usuários com perfil de administrador. Aqui é possível gerenciar usuários (adicionar, editar, remover), além de ter controle sobre as sessões WhatsApp de todos os usuários do sistema.
          </p>
          <ul className="list-disc list-inside text-gray-700 ml-4 mb-2">
            <li><strong>Gerenciar Usuários:</strong> Controle de acesso e perfis (usuário/admin).</li>
            <li><strong>Sessões WhatsApp:</strong> Iniciar, desconectar ou monitorar sessões de outros usuários.</li>
          </ul>
          <h4 className="text-lg font-semibold text-gray-800 mt-4 mb-2">Exemplo de Uso Real:</h4>
          <p className="text-gray-600 italic">
            "O administrador da plataforma cria novas contas para a equipe de vendas, concede permissões de usuário e, em caso de problemas de conexão de um vendedor, pode reiniciar a sessão WhatsApp dele remotamente."
          </p>
        </>
      ),
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-gray-800 mb-2 flex items-center justify-center">
            <HelpCircle className="w-10 h-10 text-blue-600 mr-3" />
            Central de Ajuda do MsgPanel
          </h1>
          <p className="text-gray-500 text-lg">Tudo o que você precisa saber para usar o sistema.</p>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
          <p className="text-gray-600 text-center mb-8">
            Navegue pelas seções abaixo para encontrar informações detalhadas sobre cada funcionalidade do MsgPanel.
          </p>

          <div className="space-y-8">
            {sections.map((section, index) => (
              <div key={index} className="bg-gray-50 rounded-xl shadow-md p-6 border border-gray-200">
                <h3 className="text-2xl font-semibold text-gray-800 mb-4 flex items-center">
                  {section.icon}
                  {section.title}
                </h3>
                  {section.content}
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm italic">
            Se você não encontrou a resposta para sua pergunta, por favor, entre em contato com nosso suporte.
          </p>
        </div>
      </div>
    </div>
  );
};


// 11. Componente App (Container Principal)
export default function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userRole, setUserRole] = useState('user');
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState('login'); // Inicia na página de login
  const [lastSendingResults, setLastSendingResults] = useState(null);
  
  const [loggedInUserId, setLoggedInUserId] = useState(null); 
  const [sessionStatus, setSessionStatus] = useState(null); 
  const [loadingSessionStatus, setLoadingSessionStatus] = useState(true); // Inicia como true para exibir spinner no primeiro carregamento

  const SESSION_STATUS_API_URL = 'https://app.n8n.able.tec.br/webhook/msgpanel/session-status';

  const fetchSessionStatus = useCallback(async (userId) => {
    if (!userId) {
      setSessionStatus(null); 
      setLoadingSessionStatus(false); 
      return;
    }
    // setLoadingSessionStatus(true) e setSessionStatus(null) são chamados nos useEffects que chamam esta função
    try {
      const url = `${SESSION_STATUS_API_URL}?id=${userId}`;
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Erro ao buscar status da sessão: ${response.status} ${response.statusText}`);
      }
      const data = await response.json();
      setSessionStatus(data.status); 
    } catch (error) {
      console.error("Erro ao buscar status da sessão:", error);
      setSessionStatus('ERROR'); 
    } finally {
      // Remove o atraso fixo. O loading será desativado assim que a resposta chegar.
      setLoadingSessionStatus(false); 
    }
  }, []);

  // Efeito para buscar o status da sessão quando o userId logado muda
  useEffect(() => {
    if (loggedInUserId) {
      setLoadingSessionStatus(true); // Sempre define loading como true quando uma nova busca começa
      setSessionStatus(null); // Reseta o status da sessão para null antes de buscar
      fetchSessionStatus(loggedInUserId);
    }
  }, [loggedInUserId, fetchSessionStatus]);

  // Efeito para re-verificar o status da sessão ao navegar para a página de envio de mensagens
  useEffect(() => {
    if (currentPage === 'messageSender' && loggedInUserId) {
      setLoadingSessionStatus(true); // Garante que o loading é true ao entrar na página
      setSessionStatus(null); // Reseta o status da sessão para null antes de buscar
      fetchSessionStatus(loggedInUserId);
    }
  }, [currentPage, loggedInUserId, fetchSessionStatus]);


  const handleLoginSuccess = (role, userIdFromLogin) => {
    setIsLoggedIn(true);
    setUserRole(role);
    setLoggedInUserId(userIdFromLogin);
    setCurrentPage('dashboard');
  };

  const handleLogout = () => {
    setIsLoggedIn(false);
    setUserRole('user');
    setLoggedInUserId(null);
    setSessionStatus(null); 
    setLoadingSessionStatus(true); 
    setCurrentPage('login'); // Volta para a página de login ao deslogar
  };

  const handlePurchaseAccess = () => {
    setCurrentPage('purchaseAccess'); // Define a página para a nova tela de compra de acesso
  };

  const handleReturnToLogin = () => {
    setCurrentPage('login'); // Volta para a página de login
  };

  const handleForgotPasswordClick = (e) => {
    e.preventDefault();
    setCurrentPage('forgotPassword'); // Navega para a nova página de "Esqueceu a senha?"
  };

  // Função para lidar com a conclusão do envio de mensagens
  const handleSendingComplete = useCallback((results) => {
    setLastSendingResults(results);
    setCurrentPage('sendingReport'); // Navega para a página de relatório após o envio
  }, []);

  // Função para limpar o log de envio
  const handleClearLog = useCallback(() => {
    setLastSendingResults(null);
  }, []);


  const renderPage = () => {
    switch (currentPage) {
      case 'login':
        return <LoginPage onLoginSuccess={handleLoginSuccess} onPurchaseAccess={handlePurchaseAccess} onForgotPasswordClick={handleForgotPasswordClick} />;
      case 'purchaseAccess':
        return <PurchaseAccessPage onReturnToLogin={handleReturnToLogin} />;
      case 'forgotPassword': // Nova rota para a página de "Esqueceu a senha?"
        return <ForgotPasswordPage onReturnToLogin={handleReturnToLogin} />;
      case 'dashboard':
        return <DashboardPage userId={loggedInUserId} />;
      case 'messageSender':
        return <ExcelMessageSender 
                  onSendingComplete={handleSendingComplete} 
                  userId={loggedInUserId} 
                  sessionStatus={sessionStatus} 
                  loadingSessionStatus={loadingSessionStatus}
                  setCurrentPage={setCurrentPage} 
                />;
      case 'sendingReport':
        return <SendingReportPage sendingResults={lastSendingResults} onClearLog={handleClearLog} />;
      case 'settings':
        return <SettingsPage 
                  userId={loggedInUserId} 
                  fetchSessionStatus={fetchSessionStatus} 
                  sessionStatus={sessionStatus} // Passando sessionStatus
                  loadingSessionStatus={loadingSessionStatus} // Passando loadingSessionStatus
                />; 
      case 'admin':
        return <AdminPage />;
      case 'notifications':
        return <NotificationsPage userId={loggedInUserId} />;
      case 'operationsLog':
        return <OperationsLogPage userId={loggedInUserId} />;
      case 'reports': 
        return <ReportsPage userId={loggedInUserId} />;
      case 'help': 
        return <HelpPage />;
      default:
        return <DashboardPage userId={loggedInUserId} />;
    }
  };


  if (!isLoggedIn) {
    return renderPage(); // Renderiza a página de login ou compra de acesso
  }

  return (
    <div className="flex h-screen bg-gray-100 font-sans">
      <aside
        className={`fixed inset-y-0 left-0 z-50 w-64 bg-gray-800 text-white transform ${
          isSidebarOpen ? 'translate-x-0' : '-translate-x-full'
        } lg:translate-x-0 transition-transform duration-300 ease-in-out shadow-lg`}
      >
        <div className="p-6 flex items-center justify-between border-b border-gray-700">
          <h1 className="text-2xl font-bold flex items-center">
            <MessageSquare className="w-7 h-7 mr-2 text-blue-400" />
            MsgPanel
          </h1>
          <button className="lg:hidden text-gray-400 hover:text-white" onClick={() => setIsSidebarOpen(false)} aria-label="Fechar menu">
            <X className="w-6 h-6" />
          </button>
        </div>
        <nav className="mt-8">
          <ul>
            <li 
              className={`px-6 py-3 cursor-pointer flex items-center text-gray-300 hover:text-white transition-colors duration-200 rounded-lg mx-3 mb-1 ${currentPage === 'dashboard' ? 'bg-gray-700 text-white font-semibold border-l-4 border-blue-500 shadow-md' : 'hover:bg-gray-700'}`}
              onClick={() => { setCurrentPage('dashboard'); setIsSidebarOpen(false); }}
            >
              <Home className="w-5 h-5 mr-3" /> Dashboard
            </li>
            <li 
              className={`px-6 py-3 cursor-pointer flex items-center text-gray-300 hover:text-white transition-colors duration-200 rounded-lg mx-3 mb-1 ${currentPage === 'messageSender' ? 'bg-gray-700 text-white font-semibold border-l-4 border-blue-500 shadow-md' : 'hover:bg-gray-700'}`}
              onClick={() => { 
                setIsSidebarOpen(false); 
                setCurrentPage('messageSender'); 
              }}
            >
              <MessageSquare className="w-5 h-5 mr-3" /> Envio de Mensagens
            </li>
            <li 
              className={`px-6 py-3 cursor-pointer flex items-center text-gray-300 hover:text-white transition-colors duration-200 rounded-lg mx-3 mb-1 ${currentPage === 'sendingReport' ? 'bg-gray-700 text-white font-semibold border-l-4 border-blue-500 shadow-md' : 'hover:bg-gray-700'}`}
              onClick={() => { setCurrentPage('sendingReport'); setIsSidebarOpen(false); }}
            >
              <ClipboardList className="w-5 h-5 mr-3" /> Relatório de Envio
            </li>
            <li 
              className={`px-6 py-3 cursor-pointer flex items-center text-gray-300 hover:text-white transition-colors duration-200 rounded-lg mx-3 mb-1 ${currentPage === 'reports' ? 'bg-gray-700 text-white font-semibold border-l-4 border-blue-500 shadow-md' : 'hover:bg-gray-700'}`}
              onClick={() => { setCurrentPage('reports'); setIsSidebarOpen(false); }}
            >
              <BarChart3 className="w-5 h-5 mr-3" /> Relatórios
            </li>
            {/* REMOVIDO: Opção "Contatos" */}
            {/*
            <li className="px-6 py-3 hover:bg-gray-700 cursor-pointer flex items-center text-gray-300 hover:text-white transition-colors duration-200 rounded-lg mx-3 mb-1">
              <Users className="w-5 h-5 mr-3" /> Contatos
            </li>
            */}
            <li 
              className={`px-6 py-3 cursor-pointer flex items-center text-gray-300 hover:text-white transition-colors duration-200 rounded-lg mx-3 mb-1 ${currentPage === 'settings' ? 'bg-gray-700 text-white font-semibold border-l-4 border-blue-500 shadow-md' : 'hover:bg-gray-700'}`}
              onClick={() => { setCurrentPage('settings'); setIsSidebarOpen(false); }}
            >
              <Settings className="w-5 h-5 mr-3" /> Configurações
            </li>
            {userRole === 'admin' && (
                <li 
                  className={`px-6 py-3 cursor-pointer flex items-center text-gray-300 hover:text-white transition-colors duration-200 rounded-lg mx-3 mb-1 ${currentPage === 'admin' ? 'bg-gray-700 text-white font-semibold border-l-4 border-blue-500 shadow-md' : 'hover:bg-gray-700'}`}
                  onClick={() => { setCurrentPage('admin'); setIsSidebarOpen(false); }}
                >
                  <Users className="w-5 h-5 mr-3" /> Administração
                </li>
            )}
            <li 
              className={`px-6 py-3 cursor-pointer flex items-center text-gray-300 hover:text-white transition-colors duration-200 rounded-lg mx-3 mb-1 ${currentPage === 'notifications' ? 'bg-gray-700 text-white font-semibold border-l-4 border-blue-500 shadow-md' : 'hover:bg-gray-700'}`}
              onClick={() => { setCurrentPage('notifications'); setIsSidebarOpen(false); }}
            >
              <Bell className="w-5 h-5 mr-3" /> Notificações
            </li>
            <li 
              className={`px-6 py-3 cursor-pointer flex items-center text-gray-300 hover:text-white transition-colors duration-200 rounded-lg mx-3 mb-1 ${currentPage === 'operationsLog' ? 'bg-gray-700 text-white font-semibold border-l-4 border-blue-500 shadow-md' : 'hover:bg-gray-700'}`}
              onClick={() => { setCurrentPage('operationsLog'); setIsSidebarOpen(false); }}
            >
              <Activity className="w-5 h-5 mr-3" /> Log de Operações
            </li>
            <li 
              className={`px-6 py-3 cursor-pointer flex items-center text-gray-300 hover:text-white transition-colors duration-200 rounded-lg mx-3 mb-1 ${currentPage === 'help' ? 'bg-gray-700 text-white font-semibold border-l-4 border-blue-500 shadow-md' : 'hover:bg-gray-700'}`}
              onClick={() => { setCurrentPage('help'); setIsSidebarOpen(false); }}
            >
              <HelpCircle className="w-5 h-5 mr-3" /> Ajuda
            </li>
            <li 
              className="px-6 py-3 hover:bg-gray-700 cursor-pointer flex items-center text-red-400 hover:text-red-300 transition-colors duration-200 mt-8 rounded-lg mx-3 mb-1" 
              onClick={handleLogout}
            >
              <LogOut className="w-5 h-5 mr-3" /> Sair
            </li>
          </ul>
        </nav>
      </aside>

      <div className="flex-1 flex flex-col lg:ml-64 overflow-hidden">
        <header className="bg-white shadow-sm lg:hidden p-4 flex items-center justify-between sticky top-0 z-40">
          <button className="text-gray-600 hover:text-gray-800" onClick={() => setIsSidebarOpen(true)} aria-label="Abrir menu">
            <Menu className="w-6 h-6" />
          </button>
          <h1 className="text-xl font-bold text-gray-800">MsgPanel</h1>
          <div></div> 
        </header>

        <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-50">
          {renderPage()}
        </main>
      </div>
    </div>
  );
}
